var _objectWithoutProperties = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _toConsumableArray = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _assertThisInitialized = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/helpers/assertThisInitialized.js");

var _asyncToGenerator = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _createClass = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/helpers/createClass.js");

var _regeneratorRuntime = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _defineProperty = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/helpers/defineProperty.js");

var _wrapNativeSuper = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

var _inherits = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _classCallCheck = require("/codebuild/output/src1949585164/src/github.com/Asymm-Developers/cannon-security/packages/ui/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _excluded = ["default"];

require("core-js/modules/es.promise.finally.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e17) { throw _e17; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e18) { didErr = true; err = _e18; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*! For license information please see react-carousel.js.LICENSE.txt */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define("react-carousel", ["react", "react-dom"], e) : "object" == typeof exports ? exports["react-carousel"] = e(require("react"), require("react-dom")) : t["react-carousel"] = e(t.React, t.ReactDOM);
}(this, function (t, e) {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 237);
  }([function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    t.exports = n(176)();
  }, function (t, e, n) {
    var r = n(63),
        o = "object" == typeof self && self && self.Object === Object && self,
        a = r || o || Function("return this")();
    t.exports = a;
  }, function (t, e) {
    var n = Array.isArray;
    t.exports = n;
  }, function (t, e) {
    t.exports = function (t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    };
  }, function (t, e, n) {
    var r;
    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function o() {
        for (var t = [], e = 0; e < arguments.length; e++) {
          var r = arguments[e];

          if (r) {
            var a = typeof r;
            if ("string" === a || "number" === a) t.push(r);else if (Array.isArray(r) && r.length) {
              var i = o.apply(null, r);
              i && t.push(i);
            } else if ("object" === a) for (var u in r) {
              n.call(r, u) && r[u] && t.push(u);
            }
          }
        }

        return t.join(" ");
      }

      t.exports ? (o.default = o, t.exports = o) : void 0 === (r = function () {
        return o;
      }.apply(e, [])) || (t.exports = r);
    }();
  }, function (t, e) {
    t.exports = function (t) {
      return null != t && "object" == typeof t;
    };
  }, function (t, e, n) {
    var r = n(117),
        o = n(122);

    t.exports = function (t, e) {
      var n = o(t, e);
      return r(n) ? n : void 0;
    };
  }, function (t, e, n) {
    var r = n(9),
        o = n(118),
        a = n(119),
        i = r ? r.toStringTag : void 0;

    t.exports = function (t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : i && i in Object(t) ? o(t) : a(t);
    };
  }, function (t, e, n) {
    var r = n(2).Symbol;
    t.exports = r;
  }, function (t, e) {
    t.exports = function (t) {
      return t;
    };
  }, function (t, n) {
    t.exports = e;
  }, function (t, e, n) {
    var r = n(66),
        o = n(67);

    t.exports = function (t, e, n, a) {
      var i = !n;
      n || (n = {});

      for (var u = -1, c = e.length; ++u < c;) {
        var s = e[u],
            l = a ? a(n[s], t[s], s, n, t) : void 0;
        void 0 === l && (l = t[s]), i ? o(n, s, l) : r(n, s, l);
      }

      return n;
    };
  }, function (t, e, n) {
    var r = n(69),
        o = n(139),
        a = n(14);

    t.exports = function (t) {
      return a(t) ? r(t) : o(t);
    };
  }, function (t, e, n) {
    var r = n(62),
        o = n(45);

    t.exports = function (t) {
      return null != t && o(t.length) && !r(t);
    };
  }, function (t, e, n) {
    var r = n(8),
        o = n(6);

    t.exports = function (t) {
      return "symbol" == typeof t || o(t) && "[object Symbol]" == r(t);
    };
  }, function (t, e, n) {
    var r = n(15);

    t.exports = function (t) {
      if ("string" == typeof t || r(t)) return t;
      var e = t + "";
      return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return null == t;
    };
  }, function (t, e, n) {
    var r = n(178)();
    t.exports = r;
  }, function (t, e, n) {
    var r = n(86),
        o = n(183),
        a = n(60),
        i = n(34),
        u = r(function (t, e, n) {
      var r = 1;

      if (n.length) {
        var c = i(n, a(u));
        r |= 32;
      }

      return o(t, r, e, n, c);
    });
    u.placeholder = {}, t.exports = u;
  }, function (t, e, n) {
    var r = n(107),
        o = n(108),
        a = n(109),
        i = n(110),
        u = n(111);

    function c(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var r = t[e];
        this.set(r[0], r[1]);
      }
    }

    c.prototype.clear = r, c.prototype.delete = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, t.exports = c;
  }, function (t, e, n) {
    var r = n(22);

    t.exports = function (t, e) {
      for (var n = t.length; n--;) {
        if (r(t[n][0], e)) return n;
      }

      return -1;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t === e || t != t && e != e;
    };
  }, function (t, e, n) {
    var r = n(7)(Object, "create");
    t.exports = r;
  }, function (t, e, n) {
    var r = n(131);

    t.exports = function (t, e) {
      var n = t.__data__;
      return r(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    };
  }, function (t, e) {
    var n = /^(?:0|[1-9]\d*)$/;

    t.exports = function (t, e) {
      var r = typeof t;
      return !!(e = null == e ? 9007199254740991 : e) && ("number" == r || "symbol" != r && n.test(t)) && t > -1 && t % 1 == 0 && t < e;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return function (e) {
        return t(e);
      };
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = -1,
          r = t.length;

      for (e || (e = Array(r)); ++n < r;) {
        e[n] = t[n];
      }

      return e;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = e.length, o = t.length; ++n < r;) {
        t[o + n] = e[n];
      }

      return t;
    };
  }, function (t, e, n) {
    var r = n(148),
        o = n(39),
        a = n(149),
        i = n(150),
        u = n(78),
        c = n(8),
        s = n(64),
        l = s(r),
        f = s(o),
        p = s(a),
        d = s(i),
        h = s(u),
        v = c;
    (r && "[object DataView]" != v(new r(new ArrayBuffer(1))) || o && "[object Map]" != v(new o()) || a && "[object Promise]" != v(a.resolve()) || i && "[object Set]" != v(new i()) || u && "[object WeakMap]" != v(new u())) && (v = function v(t) {
      var e = c(t),
          n = "[object Object]" == e ? t.constructor : void 0,
          r = n ? s(n) : "";
      if (r) switch (r) {
        case l:
          return "[object DataView]";

        case f:
          return "[object Map]";

        case p:
          return "[object Promise]";

        case d:
          return "[object Set]";

        case h:
          return "[object WeakMap]";
      }
      return e;
    }), t.exports = v;
  }, function (t, e, n) {
    var r = n(4),
        o = Object.create,
        a = function () {
      function t() {}

      return function (e) {
        if (!r(e)) return {};
        if (o) return o(e);
        t.prototype = e;
        var n = new t();
        return t.prototype = void 0, n;
      };
    }();

    t.exports = a;
  }, function (t, e, n) {
    var r = n(3),
        o = n(52),
        a = n(163),
        i = n(166);

    t.exports = function (t, e) {
      return r(t) ? t : o(t, e) ? [t] : a(i(t));
    };
  }, function (t, e, n) {
    var r = n(31),
        o = n(16);

    t.exports = function (t, e) {
      for (var n = 0, a = (e = r(e, t)).length; null != t && n < a;) {
        t = t[o(e[n++])];
      }

      return n && n == a ? t : void 0;
    };
  }, function (t, e, n) {
    var r = n(30),
        o = n(4);

    t.exports = function (t) {
      return function () {
        var e = arguments;

        switch (e.length) {
          case 0:
            return new t();

          case 1:
            return new t(e[0]);

          case 2:
            return new t(e[0], e[1]);

          case 3:
            return new t(e[0], e[1], e[2]);

          case 4:
            return new t(e[0], e[1], e[2], e[3]);

          case 5:
            return new t(e[0], e[1], e[2], e[3], e[4]);

          case 6:
            return new t(e[0], e[1], e[2], e[3], e[4], e[5]);

          case 7:
            return new t(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
        }

        var n = r(t.prototype),
            a = t.apply(n, e);
        return o(a) ? a : n;
      };
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = t.length, o = 0, a = []; ++n < r;) {
        var i = t[n];
        i !== e && "__lodash_placeholder__" !== i || (t[n] = "__lodash_placeholder__", a[o++] = n);
      }

      return a;
    };
  }, function (t, e, n) {
    var r = n(53);

    t.exports = function (t) {
      return null != t && t.length ? r(t, 1) : [];
    };
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var n = function () {
        if ("undefined" != typeof Map) return Map;

        function t(t, e) {
          var n = -1;
          return t.some(function (t, r) {
            return t[0] === e && (n = r, !0);
          }), n;
        }

        return function () {
          function e() {
            this.__entries__ = [];
          }

          return Object.defineProperty(e.prototype, "size", {
            get: function get() {
              return this.__entries__.length;
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.get = function (e) {
            var n = t(this.__entries__, e),
                r = this.__entries__[n];
            return r && r[1];
          }, e.prototype.set = function (e, n) {
            var r = t(this.__entries__, e);
            ~r ? this.__entries__[r][1] = n : this.__entries__.push([e, n]);
          }, e.prototype.delete = function (e) {
            var n = this.__entries__,
                r = t(n, e);
            ~r && n.splice(r, 1);
          }, e.prototype.has = function (e) {
            return !!~t(this.__entries__, e);
          }, e.prototype.clear = function () {
            this.__entries__.splice(0);
          }, e.prototype.forEach = function (t, e) {
            void 0 === e && (e = null);

            for (var n = 0, r = this.__entries__; n < r.length; n++) {
              var o = r[n];
              t.call(e, o[1], o[0]);
            }
          }, e;
        }();
      }(),
          r = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
          o = void 0 !== t && t.Math === Math ? t : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
          a = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(o) : function (t) {
        return setTimeout(function () {
          return t(Date.now());
        }, 1e3 / 60);
      },
          i = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
          u = "undefined" != typeof MutationObserver,
          c = function () {
        function t() {
          this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (t, e) {
            var n = !1,
                r = !1,
                o = 0;

            function i() {
              n && (n = !1, t()), r && c();
            }

            function u() {
              a(i);
            }

            function c() {
              var t = Date.now();

              if (n) {
                if (t - o < 2) return;
                r = !0;
              } else n = !0, r = !1, setTimeout(u, 20);

              o = t;
            }

            return c;
          }(this.refresh.bind(this));
        }

        return t.prototype.addObserver = function (t) {
          ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
        }, t.prototype.removeObserver = function (t) {
          var e = this.observers_,
              n = e.indexOf(t);
          ~n && e.splice(n, 1), !e.length && this.connected_ && this.disconnect_();
        }, t.prototype.refresh = function () {
          this.updateObservers_() && this.refresh();
        }, t.prototype.updateObservers_ = function () {
          var t = this.observers_.filter(function (t) {
            return t.gatherActive(), t.hasActive();
          });
          return t.forEach(function (t) {
            return t.broadcastActive();
          }), t.length > 0;
        }, t.prototype.connect_ = function () {
          r && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), u ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
            attributes: !0,
            childList: !0,
            characterData: !0,
            subtree: !0
          })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
        }, t.prototype.disconnect_ = function () {
          r && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
        }, t.prototype.onTransitionEnd_ = function (t) {
          var e = t.propertyName,
              n = void 0 === e ? "" : e;
          i.some(function (t) {
            return !!~n.indexOf(t);
          }) && this.refresh();
        }, t.getInstance = function () {
          return this.instance_ || (this.instance_ = new t()), this.instance_;
        }, t.instance_ = null, t;
      }(),
          s = function s(t, e) {
        for (var n = 0, r = Object.keys(e); n < r.length; n++) {
          var o = r[n];
          Object.defineProperty(t, o, {
            value: e[o],
            enumerable: !1,
            writable: !1,
            configurable: !0
          });
        }

        return t;
      },
          l = function l(t) {
        return t && t.ownerDocument && t.ownerDocument.defaultView || o;
      },
          f = b(0, 0, 0, 0);

      function p(t) {
        return parseFloat(t) || 0;
      }

      function d(t) {
        for (var e = [], n = 1; n < arguments.length; n++) {
          e[n - 1] = arguments[n];
        }

        return e.reduce(function (e, n) {
          return e + p(t["border-" + n + "-width"]);
        }, 0);
      }

      var h = "undefined" != typeof SVGGraphicsElement ? function (t) {
        return t instanceof l(t).SVGGraphicsElement;
      } : function (t) {
        return t instanceof l(t).SVGElement && "function" == typeof t.getBBox;
      };

      function v(t) {
        return r ? h(t) ? function (t) {
          var e = t.getBBox();
          return b(0, 0, e.width, e.height);
        }(t) : function (t) {
          var e = t.clientWidth,
              n = t.clientHeight;
          if (!e && !n) return f;

          var r = l(t).getComputedStyle(t),
              o = function (t) {
            for (var e = {}, n = 0, r = ["top", "right", "bottom", "left"]; n < r.length; n++) {
              var o = r[n],
                  a = t["padding-" + o];
              e[o] = p(a);
            }

            return e;
          }(r),
              a = o.left + o.right,
              i = o.top + o.bottom,
              u = p(r.width),
              c = p(r.height);

          if ("border-box" === r.boxSizing && (Math.round(u + a) !== e && (u -= d(r, "left", "right") + a), Math.round(c + i) !== n && (c -= d(r, "top", "bottom") + i)), !function (t) {
            return t === l(t).document.documentElement;
          }(t)) {
            var s = Math.round(u + a) - e,
                h = Math.round(c + i) - n;
            1 !== Math.abs(s) && (u -= s), 1 !== Math.abs(h) && (c -= h);
          }

          return b(o.left, o.top, u, c);
        }(t) : f;
      }

      function b(t, e, n, r) {
        return {
          x: t,
          y: e,
          width: n,
          height: r
        };
      }

      var y = function () {
        function t(t) {
          this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = b(0, 0, 0, 0), this.target = t;
        }

        return t.prototype.isActive = function () {
          var t = v(this.target);
          return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
        }, t.prototype.broadcastRect = function () {
          var t = this.contentRect_;
          return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
        }, t;
      }(),
          g = function g(t, e) {
        var n,
            r,
            o,
            a,
            i,
            u,
            c,
            l = (r = (n = e).x, o = n.y, a = n.width, i = n.height, u = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, c = Object.create(u.prototype), s(c, {
          x: r,
          y: o,
          width: a,
          height: i,
          top: o,
          right: r + a,
          bottom: i + o,
          left: r
        }), c);
        s(this, {
          target: t,
          contentRect: l
        });
      },
          m = function () {
        function t(t, e, r) {
          if (this.activeObservations_ = [], this.observations_ = new n(), "function" != typeof t) throw new TypeError("The callback provided as parameter 1 is not a function.");
          this.callback_ = t, this.controller_ = e, this.callbackCtx_ = r;
        }

        return t.prototype.observe = function (t) {
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

          if ("undefined" != typeof Element && Element instanceof Object) {
            if (!(t instanceof l(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
            var e = this.observations_;
            e.has(t) || (e.set(t, new y(t)), this.controller_.addObserver(this), this.controller_.refresh());
          }
        }, t.prototype.unobserve = function (t) {
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

          if ("undefined" != typeof Element && Element instanceof Object) {
            if (!(t instanceof l(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
            var e = this.observations_;
            e.has(t) && (e.delete(t), e.size || this.controller_.removeObserver(this));
          }
        }, t.prototype.disconnect = function () {
          this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
        }, t.prototype.gatherActive = function () {
          var t = this;
          this.clearActive(), this.observations_.forEach(function (e) {
            e.isActive() && t.activeObservations_.push(e);
          });
        }, t.prototype.broadcastActive = function () {
          if (this.hasActive()) {
            var t = this.callbackCtx_,
                e = this.activeObservations_.map(function (t) {
              return new g(t.target, t.broadcastRect());
            });
            this.callback_.call(t, e, t), this.clearActive();
          }
        }, t.prototype.clearActive = function () {
          this.activeObservations_.splice(0);
        }, t.prototype.hasActive = function () {
          return this.activeObservations_.length > 0;
        }, t;
      }(),
          _ = "undefined" != typeof WeakMap ? new WeakMap() : new n(),
          w = function t(e) {
        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var n = c.getInstance(),
            r = new m(e, n, this);

        _.set(this, r);
      };

      ["observe", "unobserve", "disconnect"].forEach(function (t) {
        w.prototype[t] = function () {
          var e;
          return (e = _.get(this))[t].apply(e, arguments);
        };
      });
      var O = void 0 !== o.ResizeObserver ? o.ResizeObserver : w;
      e.a = O;
    }).call(this, n(40));
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = null == t ? 0 : t.length, o = Array(r); ++n < r;) {
        o[n] = e(t[n], n, t);
      }

      return o;
    };
  }, function (t, e, n) {
    var r = n(20),
        o = n(112),
        a = n(113),
        i = n(114),
        u = n(115),
        c = n(116);

    function s(t) {
      var e = this.__data__ = new r(t);
      this.size = e.size;
    }

    s.prototype.clear = o, s.prototype.delete = a, s.prototype.get = i, s.prototype.has = u, s.prototype.set = c, t.exports = s;
  }, function (t, e, n) {
    var r = n(7)(n(2), "Map");
    t.exports = r;
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    var r = n(123),
        o = n(130),
        a = n(132),
        i = n(133),
        u = n(134);

    function c(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var r = t[e];
        this.set(r[0], r[1]);
      }
    }

    c.prototype.clear = r, c.prototype.delete = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, t.exports = c;
  }, function (t, e, n) {
    var r = n(136),
        o = n(6),
        a = Object.prototype,
        i = a.hasOwnProperty,
        u = a.propertyIsEnumerable,
        c = r(function () {
      return arguments;
    }()) ? r : function (t) {
      return o(t) && i.call(t, "callee") && !u.call(t, "callee");
    };
    t.exports = c;
  }, function (t, e, n) {
    (function (t) {
      var r = n(2),
          o = n(137),
          a = e && !e.nodeType && e,
          i = a && "object" == typeof t && t && !t.nodeType && t,
          u = i && i.exports === a ? r.Buffer : void 0,
          c = (u ? u.isBuffer : void 0) || o;
      t.exports = c;
    }).call(this, n(44)(t));
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
    };
  }, function (t, e, n) {
    (function (t) {
      var r = n(63),
          o = e && !e.nodeType && e,
          a = o && "object" == typeof t && t && !t.nodeType && t,
          i = a && a.exports === o && r.process,
          u = function () {
        try {
          return a && a.require && a.require("util").types || i && i.binding && i.binding("util");
        } catch (t) {}
      }();

      t.exports = u;
    }).call(this, n(44)(t));
  }, function (t, e) {
    var n = Object.prototype;

    t.exports = function (t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || n);
    };
  }, function (t, e, n) {
    var r = n(69),
        o = n(142),
        a = n(14);

    t.exports = function (t) {
      return a(t) ? r(t, !0) : o(t);
    };
  }, function (t, e, n) {
    var r = n(146),
        o = n(73),
        a = Object.prototype.propertyIsEnumerable,
        i = Object.getOwnPropertySymbols,
        u = i ? function (t) {
      return null == t ? [] : (t = Object(t), r(i(t), function (e) {
        return a.call(t, e);
      }));
    } : o;
    t.exports = u;
  }, function (t, e, n) {
    var r = n(72)(Object.getPrototypeOf, Object);
    t.exports = r;
  }, function (t, e, n) {
    var r = n(79);

    t.exports = function (t) {
      var e = new t.constructor(t.byteLength);
      return new r(e).set(new r(t)), e;
    };
  }, function (t, e, n) {
    var r = n(3),
        o = n(15),
        a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        i = /^\w*$/;

    t.exports = function (t, e) {
      if (r(t)) return !1;
      var n = typeof t;
      return !("number" != n && "symbol" != n && "boolean" != n && null != t && !o(t)) || i.test(t) || !a.test(t) || null != e && t in Object(e);
    };
  }, function (t, e, n) {
    var r = n(28),
        o = n(173);

    t.exports = function t(e, n, a, i, u) {
      var c = -1,
          s = e.length;

      for (a || (a = o), u || (u = []); ++c < s;) {
        var l = e[c];
        n > 0 && a(l) ? n > 1 ? t(l, n - 1, a, i, u) : r(u, l) : i || (u[u.length] = l);
      }

      return u;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      switch (n.length) {
        case 0:
          return t.call(e);

        case 1:
          return t.call(e, n[0]);

        case 2:
          return t.call(e, n[0], n[1]);

        case 3:
          return t.call(e, n[0], n[1], n[2]);
      }

      return t.apply(e, n);
    };
  }, function (t, e, n) {
    var r = n(174),
        o = n(82)(r);
    t.exports = o;
  }, function (t, e, n) {
    var r = n(30),
        o = n(57);

    function a(t, e) {
      this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = void 0;
    }

    a.prototype = r(o.prototype), a.prototype.constructor = a, t.exports = a;
  }, function (t, e) {
    t.exports = function () {};
  }, function (t, e, n) {
    var r = n(83),
        o = n(179),
        a = r ? function (t) {
      return r.get(t);
    } : o;
    t.exports = a;
  }, function (t, e, n) {
    var r = n(30),
        o = n(57);

    function a(t) {
      this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
    }

    a.prototype = r(o.prototype), a.prototype.constructor = a, t.exports = a;
  }, function (t, e) {
    t.exports = function (t) {
      return t.placeholder;
    };
  }, function (t, e, n) {
    var r = n(70),
        o = n(236),
        a = n(94),
        i = Math.min;

    t.exports = function (t, e) {
      if ((t = a(t)) < 1 || t > 9007199254740991) return [];
      var n = 4294967295,
          u = i(t, 4294967295);
      e = o(e), t -= 4294967295;

      for (var c = r(u, e); ++n < t;) {
        e(n);
      }

      return c;
    };
  }, function (t, e, n) {
    var r = n(8),
        o = n(4);

    t.exports = function (t) {
      if (!o(t)) return !1;
      var e = r(t);
      return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
    };
  }, function (t, e, n) {
    (function (e) {
      var n = "object" == typeof e && e && e.Object === Object && e;
      t.exports = n;
    }).call(this, n(40));
  }, function (t, e) {
    var n = Function.prototype.toString;

    t.exports = function (t) {
      if (null != t) {
        try {
          return n.call(t);
        } catch (t) {}

        try {
          return t + "";
        } catch (t) {}
      }

      return "";
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = null == t ? 0 : t.length; ++n < r && !1 !== e(t[n], n, t);) {
        ;
      }

      return t;
    };
  }, function (t, e, n) {
    var r = n(67),
        o = n(22),
        a = Object.prototype.hasOwnProperty;

    t.exports = function (t, e, n) {
      var i = t[e];
      a.call(t, e) && o(i, n) && (void 0 !== n || e in t) || r(t, e, n);
    };
  }, function (t, e, n) {
    var r = n(68);

    t.exports = function (t, e, n) {
      "__proto__" == e && r ? r(t, e, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : t[e] = n;
    };
  }, function (t, e, n) {
    var r = n(7),
        o = function () {
      try {
        var t = r(Object, "defineProperty");
        return t({}, "", {}), t;
      } catch (t) {}
    }();

    t.exports = o;
  }, function (t, e, n) {
    var r = n(70),
        o = n(42),
        a = n(3),
        i = n(43),
        u = n(25),
        c = n(71),
        s = Object.prototype.hasOwnProperty;

    t.exports = function (t, e) {
      var n = a(t),
          l = !n && o(t),
          f = !n && !l && i(t),
          p = !n && !l && !f && c(t),
          d = n || l || f || p,
          h = d ? r(t.length, String) : [],
          v = h.length;

      for (var b in t) {
        !e && !s.call(t, b) || d && ("length" == b || f && ("offset" == b || "parent" == b) || p && ("buffer" == b || "byteLength" == b || "byteOffset" == b) || u(b, v)) || h.push(b);
      }

      return h;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = Array(t); ++n < t;) {
        r[n] = e(n);
      }

      return r;
    };
  }, function (t, e, n) {
    var r = n(138),
        o = n(26),
        a = n(46),
        i = a && a.isTypedArray,
        u = i ? o(i) : r;
    t.exports = u;
  }, function (t, e) {
    t.exports = function (t, e) {
      return function (n) {
        return t(e(n));
      };
    };
  }, function (t, e) {
    t.exports = function () {
      return [];
    };
  }, function (t, e, n) {
    var r = n(28),
        o = n(50),
        a = n(49),
        i = n(73),
        u = Object.getOwnPropertySymbols ? function (t) {
      for (var e = []; t;) {
        r(e, a(t)), t = o(t);
      }

      return e;
    } : i;
    t.exports = u;
  }, function (t, e, n) {
    var r = n(76),
        o = n(49),
        a = n(13);

    t.exports = function (t) {
      return r(t, a, o);
    };
  }, function (t, e, n) {
    var r = n(28),
        o = n(3);

    t.exports = function (t, e, n) {
      var a = e(t);
      return o(t) ? a : r(a, n(t));
    };
  }, function (t, e, n) {
    var r = n(76),
        o = n(74),
        a = n(48);

    t.exports = function (t) {
      return r(t, a, o);
    };
  }, function (t, e, n) {
    var r = n(7)(n(2), "WeakMap");
    t.exports = r;
  }, function (t, e, n) {
    var r = n(2).Uint8Array;
    t.exports = r;
  }, function (t, e, n) {
    var r = n(35),
        o = n(81),
        a = n(55);

    t.exports = function (t) {
      return a(o(t, void 0, r), t + "");
    };
  }, function (t, e, n) {
    var r = n(54),
        o = Math.max;

    t.exports = function (t, e, n) {
      return e = o(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var a = arguments, i = -1, u = o(a.length - e, 0), c = Array(u); ++i < u;) {
          c[i] = a[e + i];
        }

        i = -1;

        for (var s = Array(e + 1); ++i < e;) {
          s[i] = a[i];
        }

        return s[e] = n(c), r(t, this, s);
      };
    };
  }, function (t, e) {
    var n = Date.now;

    t.exports = function (t) {
      var e = 0,
          r = 0;
      return function () {
        var o = n(),
            a = 16 - (o - r);

        if (r = o, a > 0) {
          if (++e >= 800) return arguments[0];
        } else e = 0;

        return t.apply(void 0, arguments);
      };
    };
  }, function (t, e, n) {
    var r = n(78),
        o = r && new r();
    t.exports = o;
  }, function (t, e, n) {
    var r = n(180),
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      for (var e = t.name + "", n = r[e], a = o.call(r, e) ? n.length : 0; a--;) {
        var i = n[a],
            u = i.func;
        if (null == u || u == t) return i.name;
      }

      return e;
    };
  }, function (t, e, n) {
    var r = n(59),
        o = n(58),
        a = n(84),
        i = n(181);

    t.exports = function (t) {
      var e = a(t),
          n = i[e];
      if ("function" != typeof n || !(e in r.prototype)) return !1;
      if (t === n) return !0;
      var u = o(n);
      return !!u && t === u[0];
    };
  }, function (t, e, n) {
    var r = n(10),
        o = n(81),
        a = n(55);

    t.exports = function (t, e) {
      return a(o(t, e, r), t + "");
    };
  }, function (t, e, n) {
    var r = n(10),
        o = n(83),
        a = o ? function (t, e) {
      return o.set(t, e), t;
    } : r;
    t.exports = a;
  }, function (t, e, n) {
    var r = n(89),
        o = n(90),
        a = n(186),
        i = n(33),
        u = n(91),
        c = n(60),
        s = n(195),
        l = n(34),
        f = n(2);

    t.exports = function t(e, n, p, d, h, v, b, y, g, m) {
      var _ = 128 & n,
          w = 1 & n,
          O = 2 & n,
          S = 24 & n,
          j = 512 & n,
          E = O ? void 0 : i(e);

      return function A() {
        for (var x = arguments.length, T = Array(x), R = x; R--;) {
          T[R] = arguments[R];
        }

        if (S) var P = c(A),
            k = a(T, P);

        if (d && (T = r(T, d, h, S)), v && (T = o(T, v, b, S)), x -= k, S && x < m) {
          var M = l(T, P);
          return u(e, n, t, A.placeholder, p, T, M, y, g, m - x);
        }

        var C = w ? p : this,
            N = O ? C[e] : e;
        return x = T.length, y ? T = s(T, y) : j && x > 1 && T.reverse(), _ && g < x && (T.length = g), this && this !== f && this instanceof A && (N = E || i(N)), N.apply(C, T);
      };
    };
  }, function (t, e) {
    var n = Math.max;

    t.exports = function (t, e, r, o) {
      for (var a = -1, i = t.length, u = r.length, c = -1, s = e.length, l = n(i - u, 0), f = Array(s + l), p = !o; ++c < s;) {
        f[c] = e[c];
      }

      for (; ++a < u;) {
        (p || a < i) && (f[r[a]] = t[a]);
      }

      for (; l--;) {
        f[c++] = t[a++];
      }

      return f;
    };
  }, function (t, e) {
    var n = Math.max;

    t.exports = function (t, e, r, o) {
      for (var a = -1, i = t.length, u = -1, c = r.length, s = -1, l = e.length, f = n(i - c, 0), p = Array(f + l), d = !o; ++a < f;) {
        p[a] = t[a];
      }

      for (var h = a; ++s < l;) {
        p[h + s] = e[s];
      }

      for (; ++u < c;) {
        (d || a < i) && (p[h + r[u]] = t[a++]);
      }

      return p;
    };
  }, function (t, e, n) {
    var r = n(85),
        o = n(92),
        a = n(93);

    t.exports = function (t, e, n, i, u, c, s, l, f, p) {
      var d = 8 & e;
      e |= d ? 32 : 64, 4 & (e &= ~(d ? 64 : 32)) || (e &= -4);
      var h = [t, e, u, d ? c : void 0, d ? s : void 0, d ? void 0 : c, d ? void 0 : s, l, f, p],
          v = n.apply(void 0, h);
      return r(t) && o(v, h), v.placeholder = i, a(v, t, e);
    };
  }, function (t, e, n) {
    var r = n(87),
        o = n(82)(r);
    t.exports = o;
  }, function (t, e, n) {
    var r = n(187),
        o = n(188),
        a = n(55),
        i = n(189);

    t.exports = function (t, e, n) {
      var u = e + "";
      return a(t, o(u, i(r(u), n)));
    };
  }, function (t, e, n) {
    var r = n(198);

    t.exports = function (t) {
      var e = r(t),
          n = e % 1;
      return e == e ? n ? e - n : e : 0;
    };
  }, function (t, e, n) {
    var r = n(199),
        o = n(4),
        a = n(15),
        i = /^[-+]0x[0-9a-f]+$/i,
        u = /^0b[01]+$/i,
        c = /^0o[0-7]+$/i,
        s = parseInt;

    t.exports = function (t) {
      if ("number" == typeof t) return t;
      if (a(t)) return NaN;

      if (o(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = o(e) ? e + "" : e;
      }

      if ("string" != typeof t) return 0 === t ? t : +t;
      t = r(t);
      var n = u.test(t);
      return n || c.test(t) ? s(t.slice(2), n ? 2 : 8) : i.test(t) ? NaN : +t;
    };
  }, function (t, e, n) {
    var r = n(207),
        o = n(6);

    t.exports = function t(e, n, a, i, u) {
      return e === n || (null == e || null == n || !o(e) && !o(n) ? e != e && n != n : r(e, n, a, i, t, u));
    };
  }, function (t, e, n) {
    var r = n(208),
        o = n(211),
        a = n(212);

    t.exports = function (t, e, n, i, u, c) {
      var s = 1 & n,
          l = t.length,
          f = e.length;
      if (l != f && !(s && f > l)) return !1;
      var p = c.get(t),
          d = c.get(e);
      if (p && d) return p == e && d == t;
      var h = -1,
          v = !0,
          b = 2 & n ? new r() : void 0;

      for (c.set(t, e), c.set(e, t); ++h < l;) {
        var y = t[h],
            g = e[h];
        if (i) var m = s ? i(g, y, h, e, t, c) : i(y, g, h, t, e, c);

        if (void 0 !== m) {
          if (m) continue;
          v = !1;
          break;
        }

        if (b) {
          if (!o(e, function (t, e) {
            if (!a(b, e) && (y === t || u(y, t, n, i, c))) return b.push(e);
          })) {
            v = !1;
            break;
          }
        } else if (y !== g && !u(y, g, n, i, c)) {
          v = !1;
          break;
        }
      }

      return c.delete(t), c.delete(e), v;
    };
  }, function (t, e, n) {
    var r = n(4);

    t.exports = function (t) {
      return t == t && !r(t);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return function (n) {
        return null != n && n[t] === e && (void 0 !== e || t in Object(n));
      };
    };
  }, function (t, e, n) {
    var r = n(37),
        o = n(106),
        a = n(162),
        i = n(31),
        u = n(12),
        c = n(171),
        s = n(80),
        l = n(77),
        f = s(function (t, e) {
      var n = {};
      if (null == t) return n;
      var s = !1;
      e = r(e, function (e) {
        return e = i(e, t), s || (s = e.length > 1), e;
      }), u(t, l(t), n), s && (n = o(n, 7, c));

      for (var f = e.length; f--;) {
        a(n, e[f]);
      }

      return n;
    });
    t.exports = f;
  }, function (t, e) {
    t.exports = function (t) {
      for (var e = -1, n = null == t ? 0 : t.length, r = 0, o = []; ++e < n;) {
        var a = t[e];
        a && (o[r++] = a);
      }

      return o;
    };
  }, function (t, e, n) {
    var r = n(201),
        o = n(4);

    t.exports = function (t, e, n) {
      var a = !0,
          i = !0;
      if ("function" != typeof t) throw new TypeError("Expected a function");
      return o(n) && (a = "leading" in n ? !!n.leading : a, i = "trailing" in n ? !!n.trailing : i), r(t, e, {
        leading: a,
        maxWait: e,
        trailing: i
      });
    };
  }, function (t, e, n) {
    var r = n(53),
        o = n(203),
        a = n(86),
        i = n(235),
        u = a(function (t, e) {
      if (null == t) return [];
      var n = e.length;
      return n > 1 && i(t, e[0], e[1]) ? e = [] : n > 2 && i(e[0], e[1], e[2]) && (e = [e[0]]), o(t, r(e, 1), []);
    });
    t.exports = u;
  }, function (t, e, n) {
    var r = n(28),
        o = n(53),
        a = n(27),
        i = n(3);

    t.exports = function () {
      var t = arguments.length;
      if (!t) return [];

      for (var e = Array(t - 1), n = arguments[0], u = t; u--;) {
        e[u - 1] = arguments[u];
      }

      return r(i(n) ? a(n) : [n], o(e, 1));
    };
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var n = "object" == typeof t && t && t.Object === Object && t;
      e.a = n;
    }).call(this, n(40));
  }, function (t, e, n) {
    var r = n(38),
        o = n(65),
        a = n(66),
        i = n(135),
        u = n(141),
        c = n(144),
        s = n(27),
        l = n(145),
        f = n(147),
        p = n(75),
        d = n(77),
        h = n(29),
        v = n(151),
        b = n(152),
        y = n(157),
        g = n(3),
        m = n(43),
        _ = n(158),
        w = n(4),
        O = n(160),
        S = n(13),
        j = n(48),
        E = {};

    E["[object Arguments]"] = E["[object Array]"] = E["[object ArrayBuffer]"] = E["[object DataView]"] = E["[object Boolean]"] = E["[object Date]"] = E["[object Float32Array]"] = E["[object Float64Array]"] = E["[object Int8Array]"] = E["[object Int16Array]"] = E["[object Int32Array]"] = E["[object Map]"] = E["[object Number]"] = E["[object Object]"] = E["[object RegExp]"] = E["[object Set]"] = E["[object String]"] = E["[object Symbol]"] = E["[object Uint8Array]"] = E["[object Uint8ClampedArray]"] = E["[object Uint16Array]"] = E["[object Uint32Array]"] = !0, E["[object Error]"] = E["[object Function]"] = E["[object WeakMap]"] = !1, t.exports = function t(e, n, A, x, T, R) {
      var P,
          k = 1 & n,
          M = 2 & n,
          C = 4 & n;
      if (A && (P = T ? A(e, x, T, R) : A(e)), void 0 !== P) return P;
      if (!w(e)) return e;
      var N = g(e);

      if (N) {
        if (P = v(e), !k) return s(e, P);
      } else {
        var L = h(e),
            D = "[object Function]" == L || "[object GeneratorFunction]" == L;
        if (m(e)) return c(e, k);

        if ("[object Object]" == L || "[object Arguments]" == L || D && !T) {
          if (P = M || D ? {} : y(e), !k) return M ? f(e, u(P, e)) : l(e, i(P, e));
        } else {
          if (!E[L]) return T ? e : {};
          P = b(e, L, k);
        }
      }

      R || (R = new r());
      var I = R.get(e);
      if (I) return I;
      R.set(e, P), O(e) ? e.forEach(function (r) {
        P.add(t(r, n, A, r, e, R));
      }) : _(e) && e.forEach(function (r, o) {
        P.set(o, t(r, n, A, o, e, R));
      });
      var V = N ? void 0 : (C ? M ? d : p : M ? j : S)(e);
      return o(V || e, function (r, o) {
        V && (r = e[o = r]), a(P, o, t(r, n, A, o, e, R));
      }), P;
    };
  }, function (t, e) {
    t.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (t, e, n) {
    var r = n(21),
        o = Array.prototype.splice;

    t.exports = function (t) {
      var e = this.__data__,
          n = r(e, t);
      return !(n < 0 || (n == e.length - 1 ? e.pop() : o.call(e, n, 1), --this.size, 0));
    };
  }, function (t, e, n) {
    var r = n(21);

    t.exports = function (t) {
      var e = this.__data__,
          n = r(e, t);
      return n < 0 ? void 0 : e[n][1];
    };
  }, function (t, e, n) {
    var r = n(21);

    t.exports = function (t) {
      return r(this.__data__, t) > -1;
    };
  }, function (t, e, n) {
    var r = n(21);

    t.exports = function (t, e) {
      var n = this.__data__,
          o = r(n, t);
      return o < 0 ? (++this.size, n.push([t, e])) : n[o][1] = e, this;
    };
  }, function (t, e, n) {
    var r = n(20);

    t.exports = function () {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = this.__data__,
          n = e.delete(t);
      return this.size = e.size, n;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return this.__data__.get(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      return this.__data__.has(t);
    };
  }, function (t, e, n) {
    var r = n(20),
        o = n(39),
        a = n(41);

    t.exports = function (t, e) {
      var n = this.__data__;

      if (n instanceof r) {
        var i = n.__data__;
        if (!o || i.length < 199) return i.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new a(i);
      }

      return n.set(t, e), this.size = n.size, this;
    };
  }, function (t, e, n) {
    var r = n(62),
        o = n(120),
        a = n(4),
        i = n(64),
        u = /^\[object .+?Constructor\]$/,
        c = Function.prototype,
        s = Object.prototype,
        l = c.toString,
        f = s.hasOwnProperty,
        p = RegExp("^" + l.call(f).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    t.exports = function (t) {
      return !(!a(t) || o(t)) && (r(t) ? p : u).test(i(t));
    };
  }, function (t, e, n) {
    var r = n(9),
        o = Object.prototype,
        a = o.hasOwnProperty,
        i = o.toString,
        u = r ? r.toStringTag : void 0;

    t.exports = function (t) {
      var e = a.call(t, u),
          n = t[u];

      try {
        t[u] = void 0;
        var r = !0;
      } catch (t) {}

      var o = i.call(t);
      return r && (e ? t[u] = n : delete t[u]), o;
    };
  }, function (t, e) {
    var n = Object.prototype.toString;

    t.exports = function (t) {
      return n.call(t);
    };
  }, function (t, e, n) {
    var r,
        o = n(121),
        a = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";

    t.exports = function (t) {
      return !!a && a in t;
    };
  }, function (t, e, n) {
    var r = n(2)["__core-js_shared__"];
    t.exports = r;
  }, function (t, e) {
    t.exports = function (t, e) {
      return null == t ? void 0 : t[e];
    };
  }, function (t, e, n) {
    var r = n(124),
        o = n(20),
        a = n(39);

    t.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (a || o)(),
        string: new r()
      };
    };
  }, function (t, e, n) {
    var r = n(125),
        o = n(126),
        a = n(127),
        i = n(128),
        u = n(129);

    function c(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var r = t[e];
        this.set(r[0], r[1]);
      }
    }

    c.prototype.clear = r, c.prototype.delete = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, t.exports = c;
  }, function (t, e, n) {
    var r = n(23);

    t.exports = function () {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    };
  }, function (t, e, n) {
    var r = n(23),
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      var e = this.__data__;

      if (r) {
        var n = e[t];
        return "__lodash_hash_undefined__" === n ? void 0 : n;
      }

      return o.call(e, t) ? e[t] : void 0;
    };
  }, function (t, e, n) {
    var r = n(23),
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      var e = this.__data__;
      return r ? void 0 !== e[t] : o.call(e, t);
    };
  }, function (t, e, n) {
    var r = n(23);

    t.exports = function (t, e) {
      var n = this.__data__;
      return this.size += this.has(t) ? 0 : 1, n[t] = r && void 0 === e ? "__lodash_hash_undefined__" : e, this;
    };
  }, function (t, e, n) {
    var r = n(24);

    t.exports = function (t) {
      var e = r(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = typeof t;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    };
  }, function (t, e, n) {
    var r = n(24);

    t.exports = function (t) {
      return r(this, t).get(t);
    };
  }, function (t, e, n) {
    var r = n(24);

    t.exports = function (t) {
      return r(this, t).has(t);
    };
  }, function (t, e, n) {
    var r = n(24);

    t.exports = function (t, e) {
      var n = r(this, t),
          o = n.size;
      return n.set(t, e), this.size += n.size == o ? 0 : 1, this;
    };
  }, function (t, e, n) {
    var r = n(12),
        o = n(13);

    t.exports = function (t, e) {
      return t && r(e, o(e), t);
    };
  }, function (t, e, n) {
    var r = n(8),
        o = n(6);

    t.exports = function (t) {
      return o(t) && "[object Arguments]" == r(t);
    };
  }, function (t, e) {
    t.exports = function () {
      return !1;
    };
  }, function (t, e, n) {
    var r = n(8),
        o = n(45),
        a = n(6),
        i = {};
    i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, t.exports = function (t) {
      return a(t) && o(t.length) && !!i[r(t)];
    };
  }, function (t, e, n) {
    var r = n(47),
        o = n(140),
        a = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      if (!r(t)) return o(t);
      var e = [];

      for (var n in Object(t)) {
        a.call(t, n) && "constructor" != n && e.push(n);
      }

      return e;
    };
  }, function (t, e, n) {
    var r = n(72)(Object.keys, Object);
    t.exports = r;
  }, function (t, e, n) {
    var r = n(12),
        o = n(48);

    t.exports = function (t, e) {
      return t && r(e, o(e), t);
    };
  }, function (t, e, n) {
    var r = n(4),
        o = n(47),
        a = n(143),
        i = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      if (!r(t)) return a(t);
      var e = o(t),
          n = [];

      for (var u in t) {
        ("constructor" != u || !e && i.call(t, u)) && n.push(u);
      }

      return n;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = [];
      if (null != t) for (var n in Object(t)) {
        e.push(n);
      }
      return e;
    };
  }, function (t, e, n) {
    (function (t) {
      var r = n(2),
          o = e && !e.nodeType && e,
          a = o && "object" == typeof t && t && !t.nodeType && t,
          i = a && a.exports === o ? r.Buffer : void 0,
          u = i ? i.allocUnsafe : void 0;

      t.exports = function (t, e) {
        if (e) return t.slice();
        var n = t.length,
            r = u ? u(n) : new t.constructor(n);
        return t.copy(r), r;
      };
    }).call(this, n(44)(t));
  }, function (t, e, n) {
    var r = n(12),
        o = n(49);

    t.exports = function (t, e) {
      return r(t, o(t), e);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = null == t ? 0 : t.length, o = 0, a = []; ++n < r;) {
        var i = t[n];
        e(i, n, t) && (a[o++] = i);
      }

      return a;
    };
  }, function (t, e, n) {
    var r = n(12),
        o = n(74);

    t.exports = function (t, e) {
      return r(t, o(t), e);
    };
  }, function (t, e, n) {
    var r = n(7)(n(2), "DataView");
    t.exports = r;
  }, function (t, e, n) {
    var r = n(7)(n(2), "Promise");
    t.exports = r;
  }, function (t, e, n) {
    var r = n(7)(n(2), "Set");
    t.exports = r;
  }, function (t, e) {
    var n = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      var e = t.length,
          r = new t.constructor(e);
      return e && "string" == typeof t[0] && n.call(t, "index") && (r.index = t.index, r.input = t.input), r;
    };
  }, function (t, e, n) {
    var r = n(51),
        o = n(153),
        a = n(154),
        i = n(155),
        u = n(156);

    t.exports = function (t, e, n) {
      var c = t.constructor;

      switch (e) {
        case "[object ArrayBuffer]":
          return r(t);

        case "[object Boolean]":
        case "[object Date]":
          return new c(+t);

        case "[object DataView]":
          return o(t, n);

        case "[object Float32Array]":
        case "[object Float64Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object Int32Array]":
        case "[object Uint8Array]":
        case "[object Uint8ClampedArray]":
        case "[object Uint16Array]":
        case "[object Uint32Array]":
          return u(t, n);

        case "[object Map]":
          return new c();

        case "[object Number]":
        case "[object String]":
          return new c(t);

        case "[object RegExp]":
          return a(t);

        case "[object Set]":
          return new c();

        case "[object Symbol]":
          return i(t);
      }
    };
  }, function (t, e, n) {
    var r = n(51);

    t.exports = function (t, e) {
      var n = e ? r(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.byteLength);
    };
  }, function (t, e) {
    var n = /\w*$/;

    t.exports = function (t) {
      var e = new t.constructor(t.source, n.exec(t));
      return e.lastIndex = t.lastIndex, e;
    };
  }, function (t, e, n) {
    var r = n(9),
        o = r ? r.prototype : void 0,
        a = o ? o.valueOf : void 0;

    t.exports = function (t) {
      return a ? Object(a.call(t)) : {};
    };
  }, function (t, e, n) {
    var r = n(51);

    t.exports = function (t, e) {
      var n = e ? r(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.length);
    };
  }, function (t, e, n) {
    var r = n(30),
        o = n(50),
        a = n(47);

    t.exports = function (t) {
      return "function" != typeof t.constructor || a(t) ? {} : r(o(t));
    };
  }, function (t, e, n) {
    var r = n(159),
        o = n(26),
        a = n(46),
        i = a && a.isMap,
        u = i ? o(i) : r;
    t.exports = u;
  }, function (t, e, n) {
    var r = n(29),
        o = n(6);

    t.exports = function (t) {
      return o(t) && "[object Map]" == r(t);
    };
  }, function (t, e, n) {
    var r = n(161),
        o = n(26),
        a = n(46),
        i = a && a.isSet,
        u = i ? o(i) : r;
    t.exports = u;
  }, function (t, e, n) {
    var r = n(29),
        o = n(6);

    t.exports = function (t) {
      return o(t) && "[object Set]" == r(t);
    };
  }, function (t, e, n) {
    var r = n(31),
        o = n(168),
        a = n(169),
        i = n(16);

    t.exports = function (t, e) {
      return e = r(e, t), null == (t = a(t, e)) || delete t[i(o(e))];
    };
  }, function (t, e, n) {
    var r = n(164),
        o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        a = /\\(\\)?/g,
        i = r(function (t) {
      var e = [];
      return 46 === t.charCodeAt(0) && e.push(""), t.replace(o, function (t, n, r, o) {
        e.push(r ? o.replace(a, "$1") : n || t);
      }), e;
    });
    t.exports = i;
  }, function (t, e, n) {
    var r = n(165);

    t.exports = function (t) {
      var e = r(t, function (t) {
        return 500 === n.size && n.clear(), t;
      }),
          n = e.cache;
      return e;
    };
  }, function (t, e, n) {
    var r = n(41);

    function o(t, e) {
      if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");

      var n = function n() {
        var r = arguments,
            o = e ? e.apply(this, r) : r[0],
            a = n.cache;
        if (a.has(o)) return a.get(o);
        var i = t.apply(this, r);
        return n.cache = a.set(o, i) || a, i;
      };

      return n.cache = new (o.Cache || r)(), n;
    }

    o.Cache = r, t.exports = o;
  }, function (t, e, n) {
    var r = n(167);

    t.exports = function (t) {
      return null == t ? "" : r(t);
    };
  }, function (t, e, n) {
    var r = n(9),
        o = n(37),
        a = n(3),
        i = n(15),
        u = r ? r.prototype : void 0,
        c = u ? u.toString : void 0;

    t.exports = function t(e) {
      if ("string" == typeof e) return e;
      if (a(e)) return o(e, t) + "";
      if (i(e)) return c ? c.call(e) : "";
      var n = e + "";
      return "0" == n && 1 / e == -1 / 0 ? "-0" : n;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = null == t ? 0 : t.length;
      return e ? t[e - 1] : void 0;
    };
  }, function (t, e, n) {
    var r = n(32),
        o = n(170);

    t.exports = function (t, e) {
      return e.length < 2 ? t : r(t, o(e, 0, -1));
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = -1,
          o = t.length;
      e < 0 && (e = -e > o ? 0 : o + e), (n = n > o ? o : n) < 0 && (n += o), o = e > n ? 0 : n - e >>> 0, e >>>= 0;

      for (var a = Array(o); ++r < o;) {
        a[r] = t[r + e];
      }

      return a;
    };
  }, function (t, e, n) {
    var r = n(172);

    t.exports = function (t) {
      return r(t) ? void 0 : t;
    };
  }, function (t, e, n) {
    var r = n(8),
        o = n(50),
        a = n(6),
        i = Function.prototype,
        u = Object.prototype,
        c = i.toString,
        s = u.hasOwnProperty,
        l = c.call(Object);

    t.exports = function (t) {
      if (!a(t) || "[object Object]" != r(t)) return !1;
      var e = o(t);
      if (null === e) return !0;
      var n = s.call(e, "constructor") && e.constructor;
      return "function" == typeof n && n instanceof n && c.call(n) == l;
    };
  }, function (t, e, n) {
    var r = n(9),
        o = n(42),
        a = n(3),
        i = r ? r.isConcatSpreadable : void 0;

    t.exports = function (t) {
      return a(t) || o(t) || !!(i && t && t[i]);
    };
  }, function (t, e, n) {
    var r = n(175),
        o = n(68),
        a = n(10),
        i = o ? function (t, e) {
      return o(t, "toString", {
        configurable: !0,
        enumerable: !1,
        value: r(e),
        writable: !0
      });
    } : a;
    t.exports = i;
  }, function (t, e) {
    t.exports = function (t) {
      return function () {
        return t;
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(177);

    function o() {}

    function a() {}

    a.resetWarningCache = o, t.exports = function () {
      function t(t, e, n, o, a, i) {
        if (i !== r) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var n = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        elementType: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return n.PropTypes = n, n;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (t, e, n) {
    var r = n(56),
        o = n(80),
        a = n(58),
        i = n(84),
        u = n(3),
        c = n(85);

    t.exports = function (t) {
      return o(function (e) {
        var n = e.length,
            o = n,
            s = r.prototype.thru;

        for (t && e.reverse(); o--;) {
          var l = e[o];
          if ("function" != typeof l) throw new TypeError("Expected a function");
          if (s && !f && "wrapper" == i(l)) var f = new r([], !0);
        }

        for (o = f ? o : n; ++o < n;) {
          l = e[o];
          var p = i(l),
              d = "wrapper" == p ? a(l) : void 0;
          f = d && c(d[0]) && 424 == d[1] && !d[4].length && 1 == d[9] ? f[i(d[0])].apply(f, d[3]) : 1 == l.length && c(l) ? f[p]() : f.thru(l);
        }

        return function () {
          var t = arguments,
              r = t[0];
          if (f && 1 == t.length && u(r)) return f.plant(r).value();

          for (var o = 0, a = n ? e[o].apply(this, t) : r; ++o < n;) {
            a = e[o].call(this, a);
          }

          return a;
        };
      });
    };
  }, function (t, e) {
    t.exports = function () {};
  }, function (t, e) {
    t.exports = {};
  }, function (t, e, n) {
    var r = n(59),
        o = n(56),
        a = n(57),
        i = n(3),
        u = n(6),
        c = n(182),
        s = Object.prototype.hasOwnProperty;

    function l(t) {
      if (u(t) && !i(t) && !(t instanceof r)) {
        if (t instanceof o) return t;
        if (s.call(t, "__wrapped__")) return c(t);
      }

      return new o(t);
    }

    l.prototype = a.prototype, l.prototype.constructor = l, t.exports = l;
  }, function (t, e, n) {
    var r = n(59),
        o = n(56),
        a = n(27);

    t.exports = function (t) {
      if (t instanceof r) return t.clone();
      var e = new o(t.__wrapped__, t.__chain__);
      return e.__actions__ = a(t.__actions__), e.__index__ = t.__index__, e.__values__ = t.__values__, e;
    };
  }, function (t, e, n) {
    var r = n(87),
        o = n(184),
        a = n(185),
        i = n(88),
        u = n(196),
        c = n(58),
        s = n(197),
        l = n(92),
        f = n(93),
        p = n(94),
        d = Math.max;

    t.exports = function (t, e, n, h, v, b, y, g) {
      var m = 2 & e;
      if (!m && "function" != typeof t) throw new TypeError("Expected a function");

      var _ = h ? h.length : 0;

      if (_ || (e &= -97, h = v = void 0), y = void 0 === y ? y : d(p(y), 0), g = void 0 === g ? g : p(g), _ -= v ? v.length : 0, 64 & e) {
        var w = h,
            O = v;
        h = v = void 0;
      }

      var S = m ? void 0 : c(t),
          j = [t, e, n, h, v, w, O, b, y, g];
      if (S && s(j, S), t = j[0], e = j[1], n = j[2], h = j[3], v = j[4], !(g = j[9] = void 0 === j[9] ? m ? 0 : t.length : d(j[9] - _, 0)) && 24 & e && (e &= -25), e && 1 != e) E = 8 == e || 16 == e ? a(t, e, g) : 32 != e && 33 != e || v.length ? i.apply(void 0, j) : u(t, e, n, h);else var E = o(t, e, n);
      return f((S ? r : l)(E, j), t, e);
    };
  }, function (t, e, n) {
    var r = n(33),
        o = n(2);

    t.exports = function (t, e, n) {
      var a = 1 & e,
          i = r(t);
      return function e() {
        var r = this && this !== o && this instanceof e ? i : t;
        return r.apply(a ? n : this, arguments);
      };
    };
  }, function (t, e, n) {
    var r = n(54),
        o = n(33),
        a = n(88),
        i = n(91),
        u = n(60),
        c = n(34),
        s = n(2);

    t.exports = function (t, e, n) {
      var l = o(t);
      return function o() {
        for (var f = arguments.length, p = Array(f), d = f, h = u(o); d--;) {
          p[d] = arguments[d];
        }

        var v = f < 3 && p[0] !== h && p[f - 1] !== h ? [] : c(p, h);
        if ((f -= v.length) < n) return i(t, e, a, o.placeholder, void 0, p, v, void 0, void 0, n - f);
        var b = this && this !== s && this instanceof o ? l : t;
        return r(b, this, p);
      };
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = t.length, r = 0; n--;) {
        t[n] === e && ++r;
      }

      return r;
    };
  }, function (t, e) {
    var n = /\{\n\/\* \[wrapped with (.+)\] \*/,
        r = /,? & /;

    t.exports = function (t) {
      var e = t.match(n);
      return e ? e[1].split(r) : [];
    };
  }, function (t, e) {
    var n = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

    t.exports = function (t, e) {
      var r = e.length;
      if (!r) return t;
      var o = r - 1;
      return e[o] = (r > 1 ? "& " : "") + e[o], e = e.join(r > 2 ? ", " : " "), t.replace(n, "{\n/* [wrapped with " + e + "] */\n");
    };
  }, function (t, e, n) {
    var r = n(65),
        o = n(190),
        a = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]];

    t.exports = function (t, e) {
      return r(a, function (n) {
        var r = "_." + n[0];
        e & n[1] && !o(t, r) && t.push(r);
      }), t.sort();
    };
  }, function (t, e, n) {
    var r = n(191);

    t.exports = function (t, e) {
      return !(null == t || !t.length) && r(t, e, 0) > -1;
    };
  }, function (t, e, n) {
    var r = n(192),
        o = n(193),
        a = n(194);

    t.exports = function (t, e, n) {
      return e == e ? a(t, e, n) : r(t, o, n);
    };
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      for (var o = t.length, a = n + (r ? 1 : -1); r ? a-- : ++a < o;) {
        if (e(t[a], a, t)) return a;
      }

      return -1;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return t != t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      for (var r = n - 1, o = t.length; ++r < o;) {
        if (t[r] === e) return r;
      }

      return -1;
    };
  }, function (t, e, n) {
    var r = n(27),
        o = n(25),
        a = Math.min;

    t.exports = function (t, e) {
      for (var n = t.length, i = a(e.length, n), u = r(t); i--;) {
        var c = e[i];
        t[i] = o(c, n) ? u[c] : void 0;
      }

      return t;
    };
  }, function (t, e, n) {
    var r = n(54),
        o = n(33),
        a = n(2);

    t.exports = function (t, e, n, i) {
      var u = 1 & e,
          c = o(t);
      return function e() {
        for (var o = -1, s = arguments.length, l = -1, f = i.length, p = Array(f + s), d = this && this !== a && this instanceof e ? c : t; ++l < f;) {
          p[l] = i[l];
        }

        for (; s--;) {
          p[l++] = arguments[++o];
        }

        return r(d, u ? n : this, p);
      };
    };
  }, function (t, e, n) {
    var r = n(89),
        o = n(90),
        a = n(34),
        i = Math.min;

    t.exports = function (t, e) {
      var n = t[1],
          u = e[1],
          c = n | u,
          s = c < 131,
          l = 128 == u && 8 == n || 128 == u && 256 == n && t[7].length <= e[8] || 384 == u && e[7].length <= e[8] && 8 == n;
      if (!s && !l) return t;
      1 & u && (t[2] = e[2], c |= 1 & n ? 0 : 4);
      var f = e[3];

      if (f) {
        var p = t[3];
        t[3] = p ? r(p, f, e[4]) : f, t[4] = p ? a(t[3], "__lodash_placeholder__") : e[4];
      }

      return (f = e[5]) && (p = t[5], t[5] = p ? o(p, f, e[6]) : f, t[6] = p ? a(t[5], "__lodash_placeholder__") : e[6]), (f = e[7]) && (t[7] = f), 128 & u && (t[8] = null == t[8] ? e[8] : i(t[8], e[8])), null == t[9] && (t[9] = e[9]), t[0] = e[0], t[1] = c, t;
    };
  }, function (t, e, n) {
    var r = n(95);

    t.exports = function (t) {
      return t ? (t = r(t)) === 1 / 0 || t === -1 / 0 ? 17976931348623157e292 * (t < 0 ? -1 : 1) : t == t ? t : 0 : 0 === t ? t : 0;
    };
  }, function (t, e, n) {
    var r = n(200),
        o = /^\s+/;

    t.exports = function (t) {
      return t ? t.slice(0, r(t) + 1).replace(o, "") : t;
    };
  }, function (t, e) {
    var n = /\s/;

    t.exports = function (t) {
      for (var e = t.length; e-- && n.test(t.charAt(e));) {
        ;
      }

      return e;
    };
  }, function (t, e, n) {
    var r = n(4),
        o = n(202),
        a = n(95),
        i = Math.max,
        u = Math.min;

    t.exports = function (t, e, n) {
      var c,
          s,
          l,
          f,
          p,
          d,
          h = 0,
          v = !1,
          b = !1,
          y = !0;
      if ("function" != typeof t) throw new TypeError("Expected a function");

      function g(e) {
        var n = c,
            r = s;
        return c = s = void 0, h = e, f = t.apply(r, n);
      }

      function m(t) {
        return h = t, p = setTimeout(w, e), v ? g(t) : f;
      }

      function _(t) {
        var n = t - d;
        return void 0 === d || n >= e || n < 0 || b && t - h >= l;
      }

      function w() {
        var t = o();
        if (_(t)) return O(t);
        p = setTimeout(w, function (t) {
          var n = e - (t - d);
          return b ? u(n, l - (t - h)) : n;
        }(t));
      }

      function O(t) {
        return p = void 0, y && c ? g(t) : (c = s = void 0, f);
      }

      function S() {
        var t = o(),
            n = _(t);

        if (c = arguments, s = this, d = t, n) {
          if (void 0 === p) return m(d);
          if (b) return clearTimeout(p), p = setTimeout(w, e), g(d);
        }

        return void 0 === p && (p = setTimeout(w, e)), f;
      }

      return e = a(e) || 0, r(n) && (v = !!n.leading, l = (b = "maxWait" in n) ? i(a(n.maxWait) || 0, e) : l, y = "trailing" in n ? !!n.trailing : y), S.cancel = function () {
        void 0 !== p && clearTimeout(p), h = 0, c = d = s = p = void 0;
      }, S.flush = function () {
        return void 0 === p ? f : O(o());
      }, S;
    };
  }, function (t, e, n) {
    var r = n(2);

    t.exports = function () {
      return r.Date.now();
    };
  }, function (t, e, n) {
    var r = n(37),
        o = n(32),
        a = n(204),
        i = n(226),
        u = n(232),
        c = n(26),
        s = n(233),
        l = n(10),
        f = n(3);

    t.exports = function (t, e, n) {
      e = e.length ? r(e, function (t) {
        return f(t) ? function (e) {
          return o(e, 1 === t.length ? t[0] : t);
        } : t;
      }) : [l];
      var p = -1;
      e = r(e, c(a));
      var d = i(t, function (t, n, o) {
        return {
          criteria: r(e, function (e) {
            return e(t);
          }),
          index: ++p,
          value: t
        };
      });
      return u(d, function (t, e) {
        return s(t, e, n);
      });
    };
  }, function (t, e, n) {
    var r = n(205),
        o = n(218),
        a = n(10),
        i = n(3),
        u = n(223);

    t.exports = function (t) {
      return "function" == typeof t ? t : null == t ? a : "object" == typeof t ? i(t) ? o(t[0], t[1]) : r(t) : u(t);
    };
  }, function (t, e, n) {
    var r = n(206),
        o = n(217),
        a = n(99);

    t.exports = function (t) {
      var e = o(t);
      return 1 == e.length && e[0][2] ? a(e[0][0], e[0][1]) : function (n) {
        return n === t || r(n, t, e);
      };
    };
  }, function (t, e, n) {
    var r = n(38),
        o = n(96);

    t.exports = function (t, e, n, a) {
      var i = n.length,
          u = i,
          c = !a;
      if (null == t) return !u;

      for (t = Object(t); i--;) {
        var s = n[i];
        if (c && s[2] ? s[1] !== t[s[0]] : !(s[0] in t)) return !1;
      }

      for (; ++i < u;) {
        var l = (s = n[i])[0],
            f = t[l],
            p = s[1];

        if (c && s[2]) {
          if (void 0 === f && !(l in t)) return !1;
        } else {
          var d = new r();
          if (a) var h = a(f, p, l, t, e, d);
          if (!(void 0 === h ? o(p, f, 3, a, d) : h)) return !1;
        }
      }

      return !0;
    };
  }, function (t, e, n) {
    var r = n(38),
        o = n(97),
        a = n(213),
        i = n(216),
        u = n(29),
        c = n(3),
        s = n(43),
        l = n(71),
        f = "[object Object]",
        p = Object.prototype.hasOwnProperty;

    t.exports = function (t, e, n, d, h, v) {
      var b = c(t),
          y = c(e),
          g = b ? "[object Array]" : u(t),
          m = y ? "[object Array]" : u(e),
          _ = (g = "[object Arguments]" == g ? f : g) == f,
          w = (m = "[object Arguments]" == m ? f : m) == f,
          O = g == m;

      if (O && s(t)) {
        if (!s(e)) return !1;
        b = !0, _ = !1;
      }

      if (O && !_) return v || (v = new r()), b || l(t) ? o(t, e, n, d, h, v) : a(t, e, g, n, d, h, v);

      if (!(1 & n)) {
        var S = _ && p.call(t, "__wrapped__"),
            j = w && p.call(e, "__wrapped__");

        if (S || j) {
          var E = S ? t.value() : t,
              A = j ? e.value() : e;
          return v || (v = new r()), h(E, A, n, d, v);
        }
      }

      return !!O && (v || (v = new r()), i(t, e, n, d, h, v));
    };
  }, function (t, e, n) {
    var r = n(41),
        o = n(209),
        a = n(210);

    function i(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.__data__ = new r(); ++e < n;) {
        this.add(t[e]);
      }
    }

    i.prototype.add = i.prototype.push = o, i.prototype.has = a, t.exports = i;
  }, function (t, e) {
    t.exports = function (t) {
      return this.__data__.set(t, "__lodash_hash_undefined__"), this;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return this.__data__.has(t);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
        if (e(t[n], n, t)) return !0;
      }

      return !1;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t.has(e);
    };
  }, function (t, e, n) {
    var r = n(9),
        o = n(79),
        a = n(22),
        i = n(97),
        u = n(214),
        c = n(215),
        s = r ? r.prototype : void 0,
        l = s ? s.valueOf : void 0;

    t.exports = function (t, e, n, r, s, f, p) {
      switch (n) {
        case "[object DataView]":
          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
          t = t.buffer, e = e.buffer;

        case "[object ArrayBuffer]":
          return !(t.byteLength != e.byteLength || !f(new o(t), new o(e)));

        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
          return a(+t, +e);

        case "[object Error]":
          return t.name == e.name && t.message == e.message;

        case "[object RegExp]":
        case "[object String]":
          return t == e + "";

        case "[object Map]":
          var d = u;

        case "[object Set]":
          var h = 1 & r;
          if (d || (d = c), t.size != e.size && !h) return !1;
          var v = p.get(t);
          if (v) return v == e;
          r |= 2, p.set(t, e);
          var b = i(d(t), d(e), r, s, f, p);
          return p.delete(t), b;

        case "[object Symbol]":
          if (l) return l.call(t) == l.call(e);
      }

      return !1;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t, r) {
        n[++e] = [r, t];
      }), n;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t) {
        n[++e] = t;
      }), n;
    };
  }, function (t, e, n) {
    var r = n(75),
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t, e, n, a, i, u) {
      var c = 1 & n,
          s = r(t),
          l = s.length;
      if (l != r(e).length && !c) return !1;

      for (var f = l; f--;) {
        var p = s[f];
        if (!(c ? p in e : o.call(e, p))) return !1;
      }

      var d = u.get(t),
          h = u.get(e);
      if (d && h) return d == e && h == t;
      var v = !0;
      u.set(t, e), u.set(e, t);

      for (var b = c; ++f < l;) {
        var y = t[p = s[f]],
            g = e[p];
        if (a) var m = c ? a(g, y, p, e, t, u) : a(y, g, p, t, e, u);

        if (!(void 0 === m ? y === g || i(y, g, n, a, u) : m)) {
          v = !1;
          break;
        }

        b || (b = "constructor" == p);
      }

      if (v && !b) {
        var _ = t.constructor,
            w = e.constructor;
        _ == w || !("constructor" in t) || !("constructor" in e) || "function" == typeof _ && _ instanceof _ && "function" == typeof w && w instanceof w || (v = !1);
      }

      return u.delete(t), u.delete(e), v;
    };
  }, function (t, e, n) {
    var r = n(98),
        o = n(13);

    t.exports = function (t) {
      for (var e = o(t), n = e.length; n--;) {
        var a = e[n],
            i = t[a];
        e[n] = [a, i, r(i)];
      }

      return e;
    };
  }, function (t, e, n) {
    var r = n(96),
        o = n(219),
        a = n(220),
        i = n(52),
        u = n(98),
        c = n(99),
        s = n(16);

    t.exports = function (t, e) {
      return i(t) && u(e) ? c(s(t), e) : function (n) {
        var i = o(n, t);
        return void 0 === i && i === e ? a(n, t) : r(e, i, 3);
      };
    };
  }, function (t, e, n) {
    var r = n(32);

    t.exports = function (t, e, n) {
      var o = null == t ? void 0 : r(t, e);
      return void 0 === o ? n : o;
    };
  }, function (t, e, n) {
    var r = n(221),
        o = n(222);

    t.exports = function (t, e) {
      return null != t && o(t, e, r);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return null != t && e in Object(t);
    };
  }, function (t, e, n) {
    var r = n(31),
        o = n(42),
        a = n(3),
        i = n(25),
        u = n(45),
        c = n(16);

    t.exports = function (t, e, n) {
      for (var s = -1, l = (e = r(e, t)).length, f = !1; ++s < l;) {
        var p = c(e[s]);
        if (!(f = null != t && n(t, p))) break;
        t = t[p];
      }

      return f || ++s != l ? f : !!(l = null == t ? 0 : t.length) && u(l) && i(p, l) && (a(t) || o(t));
    };
  }, function (t, e, n) {
    var r = n(224),
        o = n(225),
        a = n(52),
        i = n(16);

    t.exports = function (t) {
      return a(t) ? r(i(t)) : o(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      return function (e) {
        return null == e ? void 0 : e[t];
      };
    };
  }, function (t, e, n) {
    var r = n(32);

    t.exports = function (t) {
      return function (e) {
        return r(e, t);
      };
    };
  }, function (t, e, n) {
    var r = n(227),
        o = n(14);

    t.exports = function (t, e) {
      var n = -1,
          a = o(t) ? Array(t.length) : [];
      return r(t, function (t, r, o) {
        a[++n] = e(t, r, o);
      }), a;
    };
  }, function (t, e, n) {
    var r = n(228),
        o = n(231)(r);
    t.exports = o;
  }, function (t, e, n) {
    var r = n(229),
        o = n(13);

    t.exports = function (t, e) {
      return t && r(t, e, o);
    };
  }, function (t, e, n) {
    var r = n(230)();
    t.exports = r;
  }, function (t, e) {
    t.exports = function (t) {
      return function (e, n, r) {
        for (var o = -1, a = Object(e), i = r(e), u = i.length; u--;) {
          var c = i[t ? u : ++o];
          if (!1 === n(a[c], c, a)) break;
        }

        return e;
      };
    };
  }, function (t, e, n) {
    var r = n(14);

    t.exports = function (t, e) {
      return function (n, o) {
        if (null == n) return n;
        if (!r(n)) return t(n, o);

        for (var a = n.length, i = e ? a : -1, u = Object(n); (e ? i-- : ++i < a) && !1 !== o(u[i], i, u);) {
          ;
        }

        return n;
      };
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = t.length;

      for (t.sort(e); n--;) {
        t[n] = t[n].value;
      }

      return t;
    };
  }, function (t, e, n) {
    var r = n(234);

    t.exports = function (t, e, n) {
      for (var o = -1, a = t.criteria, i = e.criteria, u = a.length, c = n.length; ++o < u;) {
        var s = r(a[o], i[o]);
        if (s) return o >= c ? s : s * ("desc" == n[o] ? -1 : 1);
      }

      return t.index - e.index;
    };
  }, function (t, e, n) {
    var r = n(15);

    t.exports = function (t, e) {
      if (t !== e) {
        var n = void 0 !== t,
            o = null === t,
            a = t == t,
            i = r(t),
            u = void 0 !== e,
            c = null === e,
            s = e == e,
            l = r(e);
        if (!c && !l && !i && t > e || i && u && s && !c && !l || o && u && s || !n && s || !a) return 1;
        if (!o && !i && !l && t < e || l && n && a && !o && !i || c && n && a || !u && a || !s) return -1;
      }

      return 0;
    };
  }, function (t, e, n) {
    var r = n(22),
        o = n(14),
        a = n(25),
        i = n(4);

    t.exports = function (t, e, n) {
      if (!i(n)) return !1;
      var u = typeof e;
      return !!("number" == u ? o(n) && a(e, n.length) : "string" == u && e in n) && r(n[e], t);
    };
  }, function (t, e, n) {
    var r = n(10);

    t.exports = function (t) {
      return "function" == typeof t ? t : r;
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "slidesToShowPlugin", function () {
      return ki;
    }), n.d(e, "infinitePlugin", function () {
      return Mi;
    }), n.d(e, "clickToChangePlugin", function () {
      return Ci;
    }), n.d(e, "autoplayPlugin", function () {
      return Ni;
    }), n.d(e, "rtlPlugin", function () {
      return Li;
    }), n.d(e, "centeredPlugin", function () {
      return Di;
    }), n.d(e, "slidesToScrollPlugin", function () {
      return Ii;
    }), n.d(e, "arrowsPlugin", function () {
      return Vi;
    }), n.d(e, "fastSwipePlugin", function () {
      return Bi;
    }), n.d(e, "Dots", function () {
      return Ui;
    });
    var r = n(0),
        o = n.n(r),
        a = n(11),
        i = n.n(a);

    function u(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var c = function c(t) {
      _classCallCheck(this, c);

      u(this, "key", void 0), this.key = t;
    };

    var s = /*#__PURE__*/function (_c) {
      _inherits(s, _c);

      var _super = _createSuper(s);

      function s() {
        _classCallCheck(this, s);

        return _super.apply(this, arguments);
      }

      return s;
    }(c);

    var l = /*#__PURE__*/function (_c2) {
      _inherits(l, _c2);

      var _super2 = _createSuper(l);

      function l() {
        _classCallCheck(this, l);

        return _super2.apply(this, arguments);
      }

      return l;
    }(c);

    var f = {
      AbstractRecoilValue: c,
      RecoilState: s,
      RecoilValueReadOnly: l,
      isRecoilValue: function isRecoilValue(t) {
        return t instanceof s || t instanceof l;
      }
    },
        p = f.AbstractRecoilValue,
        d = f.RecoilState,
        h = f.RecoilValueReadOnly,
        v = f.isRecoilValue,
        b = Object.freeze({
      __proto__: null,
      AbstractRecoilValue: p,
      RecoilState: d,
      RecoilValueReadOnly: h,
      isRecoilValue: v
    });

    var y = function y() {
      _classCallCheck(this, y);
    };

    var g = new y();

    var m = /*#__PURE__*/function (_Error) {
      _inherits(m, _Error);

      var _super3 = _createSuper(m);

      function m(t) {
        _classCallCheck(this, m);

        return _super3.call(this, "Tried to set the value of Recoil selector ".concat(t, " using an updater function, but it is an async selector in a pending or error state; this is not supported."));
      }

      return m;
    }( /*#__PURE__*/_wrapNativeSuper(Error));

    var _ = new Map(),
        w = new Map();

    var O = /*#__PURE__*/function (_Error2) {
      _inherits(O, _Error2);

      var _super4 = _createSuper(O);

      function O() {
        _classCallCheck(this, O);

        return _super4.apply(this, arguments);
      }

      return O;
    }( /*#__PURE__*/_wrapNativeSuper(Error));

    var S = {
      nodes: _,
      recoilValues: w,
      registerNode: function registerNode(t) {
        if (_.has(t.key)) {
          t.key;
        }

        _.set(t.key, t);

        var e = null == t.set ? new b.RecoilValueReadOnly(t.key) : new b.RecoilState(t.key);
        return w.set(t.key, e), e;
      },
      getNode: function getNode(t) {
        var e = _.get(t);

        if (null == e) throw new O("Missing definition for RecoilValue: \"".concat(t, "\"\""));
        return e;
      },
      getNodeMaybe: function getNodeMaybe(t) {
        return _.get(t);
      },
      NodeMissingError: O,
      DefaultValue: y,
      DEFAULT_VALUE: g,
      RecoilValueNotReady: m
    },
        j = function j(t, e) {
      e();
    },
        E = {
      setByAddingToSet: function setByAddingToSet(t, e) {
        var n = new Set(t);
        return n.add(e), n;
      },
      setByDeletingFromSet: function setByDeletingFromSet(t, e) {
        var n = new Set(t);
        return n.delete(e), n;
      },
      mapBySettingInMap: function mapBySettingInMap(t, e, n) {
        var r = new Map(t);
        return r.set(e, n), r;
      },
      mapByUpdatingInMap: function mapByUpdatingInMap(t, e, n) {
        var r = new Map(t);
        return r.set(e, n(r.get(e))), r;
      },
      mapByDeletingFromMap: function mapByDeletingFromMap(t, e) {
        var n = new Map(t);
        return n.delete(e), n;
      },
      mapByDeletingMultipleFromMap: function mapByDeletingMultipleFromMap(t, e) {
        var n = new Map(t);
        return e.forEach(function (t) {
          return n.delete(t);
        }), n;
      }
    };

    var A = E.mapByDeletingFromMap,
        x = E.mapBySettingInMap,
        T = E.setByAddingToSet,
        R = S.getNode,
        P = S.getNodeMaybe,
        k = Object.freeze(new Set());

    var M = /*#__PURE__*/function (_Error3) {
      _inherits(M, _Error3);

      var _super5 = _createSuper(M);

      function M() {
        _classCallCheck(this, M);

        return _super5.apply(this, arguments);
      }

      return M;
    }( /*#__PURE__*/_wrapNativeSuper(Error));

    var C = {
      getNodeLoadable: function getNodeLoadable(t, e, n) {
        return R(n).get(t, e);
      },
      peekNodeLoadable: function peekNodeLoadable(t, e, n) {
        return R(n).peek(t, e);
      },
      setNodeValue: function setNodeValue(t, e, n, r) {
        var o = R(n);
        if (null == o.set) throw new M("Attempt to set read-only RecoilValue: " + n);
        return o.set(t, e, r);
      },
      setUnvalidatedAtomValue: function setUnvalidatedAtomValue(t, e, n) {
        var r;
        var o = P(e);
        return null == o || null === (r = o.invalidate) || void 0 === r || r.call(o), _objectSpread(_objectSpread({}, t), {}, {
          atomValues: A(t.atomValues, e),
          nonvalidatedAtoms: x(t.nonvalidatedAtoms, e, n),
          dirtyAtoms: T(t.dirtyAtoms, e)
        });
      },
      getDownstreamNodes: function getDownstreamNodes(t, e, n) {
        var r = new Set(),
            o = Array.from(n),
            a = t.getGraph(e.version);

        for (var _t2 = o.pop(); _t2; _t2 = o.pop()) {
          var i;
          r.add(_t2);

          var _e2 = null !== (i = a.nodeToNodeSubscriptions.get(_t2)) && void 0 !== i ? i : k;

          var _iterator = _createForOfIteratorHelper(_e2),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _t3 = _step.value;
              r.has(_t3) || o.push(_t3);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        return r;
      }
    },
        N = function N(t) {
      var n = new Set();

      for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        e[_key - 1] = arguments[_key];
      }

      var _iterator2 = _createForOfIteratorHelper(t),
          _step2;

      try {
        t: for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _r2 = _step2.value;

          var _iterator3 = _createForOfIteratorHelper(e),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _t4 = _step3.value;
              if (_t4.has(_r2)) continue t;
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          n.add(_r2);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return n;
    },
        L = function L(t, e) {
      var n = new Map();
      return t.forEach(function (t, r) {
        n.set(r, e(t, r));
      }), n;
    },
        D = function D(t, e) {
      if (null != t) return t;
      throw new Error(null != e ? e : "Got unexpected null or undefined");
    };

    function I(t, e, n) {
      var r = e.nodeDeps,
          o = e.nodeToNodeSubscriptions;
      t.forEach(function (t, e) {
        var a = r.get(e);
        a && n && a !== n.nodeDeps.get(e) || (r.set(e, new Set(t)), (null == a ? t : N(t, a)).forEach(function (t) {
          o.has(t) || o.set(t, new Set()), D(o.get(t)).add(e);
        }), a && N(a, t).forEach(function (t) {
          if (!o.has(t)) return;
          var n = D(o.get(t));
          n.delete(e), 0 === n.size && o.delete(t);
        }));
      });
    }

    var V = {
      addToDependencyMap: function addToDependencyMap(t, e, n) {
        n.has(t) || n.set(t, new Set()), D(n.get(t)).add(e);
      },
      cloneGraph: function cloneGraph(t) {
        return {
          nodeDeps: L(t.nodeDeps, function (t) {
            return new Set(t);
          }),
          nodeToNodeSubscriptions: L(t.nodeToNodeSubscriptions, function (t) {
            return new Set(t);
          })
        };
      },
      graph: function graph() {
        return {
          nodeDeps: new Map(),
          nodeToNodeSubscriptions: new Map()
        };
      },
      mergeDepsIntoDependencyMap: function mergeDepsIntoDependencyMap(t, e) {
        t.forEach(function (t, n) {
          e.has(n) || e.set(n, new Set());
          var r = D(e.get(n));
          t.forEach(function (t) {
            return r.add(t);
          });
        });
      },
      saveDependencyMapToStore: function saveDependencyMapToStore(t, e, n) {
        var r, o, a, i;
        var u = e.getState();
        n !== u.currentTree.version && n !== (null === (r = u.nextTree) || void 0 === r ? void 0 : r.version) && (null === (o = u.previousTree) || void 0 === o || o.version);
        var c = e.getGraph(n);

        if (I(t, c), n === (null === (a = u.previousTree) || void 0 === a ? void 0 : a.version) && I(t, e.getGraph(u.currentTree.version), c), n === (null === (i = u.previousTree) || void 0 === i ? void 0 : i.version) || n === u.currentTree.version) {
          var s;

          var _n2 = null === (s = u.nextTree) || void 0 === s ? void 0 : s.version;

          void 0 !== _n2 && I(t, e.getGraph(_n2), c);
        }
      }
    },
        B = function B(t, e, n) {
      return n();
    },
        U = function U(t) {
      return t;
    },
        F = function F() {
      var e = new Set();

      for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        t[_key2] = arguments[_key2];
      }

      for (var _i2 = 0, _t5 = t; _i2 < _t5.length; _i2++) {
        var _n3 = _t5[_i2];

        var _iterator4 = _createForOfIteratorHelper(_n3),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _t6 = _step4.value;
            e.add(_t6);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      return e;
    };

    var W = E.mapByDeletingFromMap,
        z = E.mapByDeletingMultipleFromMap,
        $ = C.getNodeLoadable,
        H = C.setNodeValue,
        G = C.setUnvalidatedAtomValue,
        q = V.saveDependencyMapToStore,
        X = S.DefaultValue,
        Y = S.RecoilValueNotReady,
        K = b.AbstractRecoilValue,
        J = b.RecoilState,
        Q = b.RecoilValueReadOnly,
        Z = b.isRecoilValue;

    function tt(t, e) {
      var n = L(t, function (t) {
        return t;
      });
      return e.forEach(function (t, e) {
        "hasValue" === t.state && t.contents instanceof X ? n.delete(e) : n.set(e, t);
      }), n;
    }

    function et(t, e, n) {
      var r = e.key;
      B("set RecoilValue", r, function () {
        return t.replaceState(U(function (o) {
          var a = function (t, _ref, n) {
            var e = _ref.key;

            if ("function" == typeof n) {
              var r;

              var _o2 = t.getState(),
                  _a2 = null !== (r = _o2.nextTree) && void 0 !== r ? r : _o2.currentTree,
                  _i3 = $(t, _a2, e)[1];

              if ("loading" === _i3.state) throw new Y(e);
              if ("hasError" === _i3.state) throw _i3.contents;
              return n(_i3.contents);
            }

            return n;
          }(t, e, n),
              _H = H(t, o, r, a),
              _H2 = _slicedToArray(_H, 2),
              i = _H2[0],
              u = _H2[1],
              c = new Set(u.keys());

          return q(i, t, o.version), _objectSpread(_objectSpread({}, o), {}, {
            dirtyAtoms: F(o.dirtyAtoms, c),
            atomValues: tt(o.atomValues, u),
            nonvalidatedAtoms: z(o.nonvalidatedAtoms, c)
          });
        }));
      });
    }

    var nt = 0;

    var rt = {
      RecoilValueReadOnly: Q,
      AbstractRecoilValue: K,
      RecoilState: J,
      getRecoilValueAsLoadable: function getRecoilValueAsLoadable(t, _ref2) {
        var e = _ref2.key;
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t.getState().currentTree;
        var r, o;
        var a = t.getState();
        n.version !== a.currentTree.version && n.version !== (null === (r = a.nextTree) || void 0 === r ? void 0 : r.version) && (n.version, null === (o = a.previousTree) || void 0 === o || o.version);

        var _$ = $(t, n, e),
            _$2 = _slicedToArray(_$, 2),
            i = _$2[0],
            u = _$2[1];

        return q(i, t, n.version), u;
      },
      setRecoilValue: et,
      setRecoilValueLoadable: function setRecoilValueLoadable(t, e, n) {
        if (n instanceof X) return et(t, e, n);
        var r = e.key;
        B("set RecoilValue", r, function () {
          return t.replaceState(U(function (t) {
            var e = new Set([r]);
            return _objectSpread(_objectSpread({}, t), {}, {
              dirtyAtoms: F(t.dirtyAtoms, e),
              atomValues: tt(t.atomValues, new Map([[r, n]])),
              nonvalidatedAtoms: W(t.nonvalidatedAtoms, r)
            });
          }));
        });
      },
      markRecoilValueModified: function markRecoilValueModified(t, _ref3) {
        var e = _ref3.key;
        B("mark RecoilValue modified", e, function () {
          return t.replaceState(U(function (t) {
            return _objectSpread(_objectSpread({}, t), {}, {
              dirtyAtoms: F(t.dirtyAtoms, new Set([e]))
            });
          }));
        });
      },
      setUnvalidatedRecoilValue: function setUnvalidatedRecoilValue(t, _ref4, n) {
        var e = _ref4.key;
        B("set unvalidated persisted atom", e, function () {
          return t.replaceState(U(function (t) {
            return G(t, e, n);
          }));
        });
      },
      subscribeToRecoilValue: function subscribeToRecoilValue(t, _ref5, n) {
        var e = _ref5.key;
        var r = nt++,
            o = t.getState();
        return o.nodeToComponentSubscriptions.has(e) || o.nodeToComponentSubscriptions.set(e, new Map()), D(o.nodeToComponentSubscriptions.get(e)).set(r, ["TODO debug name", n]), {
          release: function release() {
            var n = t.getState(),
                o = n.nodeToComponentSubscriptions.get(e);
            void 0 !== o && o.has(r) && (o.delete(r), 0 === o.size && n.nodeToComponentSubscriptions.delete(e));
          }
        };
      },
      isRecoilValue: Z,
      applyAtomValueWrites: tt
    },
        ot = /*#__PURE__*/_regeneratorRuntime.mark(function ot(t, e) {
      var n, _iterator5, _step5, _r3;

      return _regeneratorRuntime.wrap(function ot$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              n = 0;
              _iterator5 = _createForOfIteratorHelper(t);
              _context.prev = 2;

              _iterator5.s();

            case 4:
              if ((_step5 = _iterator5.n()).done) {
                _context.next = 12;
                break;
              }

              _r3 = _step5.value;
              _context.t0 = e(_r3, n++);

              if (!_context.t0) {
                _context.next = 10;
                break;
              }

              _context.next = 10;
              return _r3;

            case 10:
              _context.next = 4;
              break;

            case 12:
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t1 = _context["catch"](2);

              _iterator5.e(_context.t1);

            case 17:
              _context.prev = 17;

              _iterator5.f();

              return _context.finish(17);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, ot, null, [[2, 14, 17, 20]]);
    });

    var at = new Map();

    function it(t) {
      var e;
      return null !== (e = at.get(t)) && void 0 !== e && e;
    }

    it.setPass = function (t) {
      at.set(t, !0);
    }, it.setFail = function (t) {
      at.set(t, !1);
    };
    var ut = it;
    var ct = V.graph;
    var st = 0;

    var lt = function lt() {
      return st++;
    };

    function ft() {
      var t = lt();
      return {
        version: t,
        stateID: t,
        transactionMetadata: {},
        dirtyAtoms: new Set(),
        atomValues: new Map(),
        nonvalidatedAtoms: new Map()
      };
    }

    var pt = {
      makeEmptyTreeState: ft,
      makeEmptyStoreState: function makeEmptyStoreState() {
        var t = ft();
        return {
          currentTree: t,
          nextTree: null,
          previousTree: null,
          knownAtoms: new Set(),
          knownSelectors: new Set(),
          transactionSubscriptions: new Map(),
          nodeTransactionSubscriptions: new Map(),
          nodeToComponentSubscriptions: new Map(),
          queuedComponentCallbacks_DEPRECATED: [],
          suspendedComponentResolvers: new Set(),
          graphsByVersion: new Map().set(t.version, ct()),
          versionsUsedByComponent: new Map()
        };
      },
      getNextTreeStateVersion: lt
    };
    var dt = C.getDownstreamNodes,
        ht = C.peekNodeLoadable,
        vt = V.graph,
        bt = S.DEFAULT_VALUE,
        yt = S.recoilValues,
        gt = rt.getRecoilValueAsLoadable,
        mt = rt.setRecoilValue,
        _t = pt.getNextTreeStateVersion,
        wt = pt.makeEmptyStoreState;

    function Ot(t) {
      return function (t, e) {
        return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var n, _iterator6, _step6, _r4;

          return _regeneratorRuntime.wrap(function _callee$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  n = 0;
                  _iterator6 = _createForOfIteratorHelper(t);
                  _context2.prev = 2;

                  _iterator6.s();

                case 4:
                  if ((_step6 = _iterator6.n()).done) {
                    _context2.next = 10;
                    break;
                  }

                  _r4 = _step6.value;
                  _context2.next = 8;
                  return e(_r4, n++);

                case 8:
                  _context2.next = 4;
                  break;

                case 10:
                  _context2.next = 15;
                  break;

                case 12:
                  _context2.prev = 12;
                  _context2.t0 = _context2["catch"](2);

                  _iterator6.e(_context2.t0);

                case 15:
                  _context2.prev = 15;

                  _iterator6.f();

                  return _context2.finish(15);

                case 18:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee, null, [[2, 12, 15, 18]]);
        })();
      }(t, function (t) {
        return D(yt.get(t));
      });
    }

    var St = /*#__PURE__*/function () {
      function St(t) {
        var _this = this;

        _classCallCheck(this, St);

        u(this, "_store", void 0), u(this, "getLoadable", function (t) {
          return gt(_this._store, t);
        }), u(this, "getPromise", function (t) {
          return ut("recoil_async_selector_refactor") ? _this.getLoadable(t).toPromise().then(function (_ref6) {
            var t = _ref6.value;
            return t;
          }) : _this.getLoadable(t).toPromise();
        }), u(this, "getNodes_UNSTABLE", function (t) {
          if (!0 === (null == t ? void 0 : t.isModified)) return !1 === (null == t ? void 0 : t.isInitialized) ? [] : Ot(_this._store.getState().currentTree.dirtyAtoms);

          var e = _this._store.getState().knownAtoms,
              n = _this._store.getState().knownSelectors;

          return null == (null == t ? void 0 : t.isInitialized) ? yt.values() : !0 === t.isInitialized ? Ot( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
            var _iterator7, _step7, _e3, _iterator8, _step8, _t7;

            return _regeneratorRuntime.wrap(function _callee2$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _iterator7 = _createForOfIteratorHelper(t);
                    _context3.prev = 1;

                    _iterator7.s();

                  case 3:
                    if ((_step7 = _iterator7.n()).done) {
                      _context3.next = 24;
                      break;
                    }

                    _e3 = _step7.value;
                    _iterator8 = _createForOfIteratorHelper(_e3);
                    _context3.prev = 6;

                    _iterator8.s();

                  case 8:
                    if ((_step8 = _iterator8.n()).done) {
                      _context3.next = 14;
                      break;
                    }

                    _t7 = _step8.value;
                    _context3.next = 12;
                    return _t7;

                  case 12:
                    _context3.next = 8;
                    break;

                  case 14:
                    _context3.next = 19;
                    break;

                  case 16:
                    _context3.prev = 16;
                    _context3.t0 = _context3["catch"](6);

                    _iterator8.e(_context3.t0);

                  case 19:
                    _context3.prev = 19;

                    _iterator8.f();

                    return _context3.finish(19);

                  case 22:
                    _context3.next = 3;
                    break;

                  case 24:
                    _context3.next = 29;
                    break;

                  case 26:
                    _context3.prev = 26;
                    _context3.t1 = _context3["catch"](1);

                    _iterator7.e(_context3.t1);

                  case 29:
                    _context3.prev = 29;

                    _iterator7.f();

                    return _context3.finish(29);

                  case 32:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee2, null, [[1, 26, 29, 32], [6, 16, 19, 22]]);
          })([_this._store.getState().knownAtoms, _this._store.getState().knownSelectors])) : ot(yt.values(), function (_ref7) {
            var t = _ref7.key;
            return !e.has(t) && !n.has(t);
          });
        }), u(this, "getDeps_UNSTABLE", function (t) {
          _this.getLoadable(t);

          var e = _this._store.getGraph(_this._store.getState().currentTree.version).nodeDeps.get(t.key);

          return Ot(null != e ? e : []);
        }), u(this, "getSubscribers_UNSTABLE", function (_ref8) {
          var t = _ref8.key;

          var e = _this._store.getState().currentTree;

          return {
            nodes: Ot(ot(dt(_this._store, e, new Set([t])), function (e) {
              return e !== t;
            }))
          };
        }), u(this, "getInfo_UNSTABLE", function (t) {
          var e;

          var n = t.key,
              r = _this._store.getState().currentTree,
              o = _this._store.getGraph(r.version);

          return {
            loadable: ht(_this._store, r, n),
            isActive: _this._store.getState().knownAtoms.has(n) || _this._store.getState().knownSelectors.has(n),
            isSet: r.atomValues.has(n),
            isModified: r.dirtyAtoms.has(n),
            type: _this._store.getState().knownAtoms.has(n) ? "atom" : _this._store.getState().knownSelectors.has(n) ? "selector" : void 0,
            deps: Ot(null !== (e = o.nodeDeps.get(n)) && void 0 !== e ? e : []),
            subscribers: _this.getSubscribers_UNSTABLE(t)
          };
        }), u(this, "map", function (t) {
          var e = new At(_this);
          return t(e), Et(e.getStore_INTERNAL());
        }), u(this, "asyncMap", /*#__PURE__*/function () {
          var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
            var e;
            return _regeneratorRuntime.wrap(function _callee3$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    e = new At(_this);
                    _context4.next = 3;
                    return t(e);

                  case 3:
                    return _context4.abrupt("return", Et(e.getStore_INTERNAL()));

                  case 4:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x) {
            return _ref9.apply(this, arguments);
          };
        }()), this._store = {
          getState: function getState() {
            return t;
          },
          replaceState: function replaceState(e) {
            t.currentTree = e(t.currentTree);
          },
          getGraph: function getGraph(e) {
            var n = t.graphsByVersion;
            if (n.has(e)) return D(n.get(e));
            var r = vt();
            return n.set(e, r), r;
          },
          subscribeToTransactions: function subscribeToTransactions() {
            return {
              release: function release() {}
            };
          },
          addTransactionMetadata: function addTransactionMetadata() {
            throw new Error("Cannot subscribe to Snapshots");
          }
        };
      }

      _createClass(St, [{
        key: "getStore_INTERNAL",
        value: function getStore_INTERNAL() {
          return this._store;
        }
      }, {
        key: "getID",
        value: function getID() {
          return this.getID_INTERNAL();
        }
      }, {
        key: "getID_INTERNAL",
        value: function getID_INTERNAL() {
          return this._store.getState().currentTree.stateID;
        }
      }]);

      return St;
    }();

    function jt(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var r = t.getState(),
          o = n ? _t() : e.version;
      return {
        currentTree: n ? {
          version: o,
          stateID: o,
          transactionMetadata: _objectSpread({}, e.transactionMetadata),
          dirtyAtoms: new Set(e.dirtyAtoms),
          atomValues: new Map(e.atomValues),
          nonvalidatedAtoms: new Map(e.nonvalidatedAtoms)
        } : e,
        nextTree: null,
        previousTree: null,
        knownAtoms: new Set(r.knownAtoms),
        knownSelectors: new Set(r.knownSelectors),
        transactionSubscriptions: new Map(),
        nodeTransactionSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map(),
        queuedComponentCallbacks_DEPRECATED: [],
        suspendedComponentResolvers: new Set(),
        graphsByVersion: new Map().set(o, t.getGraph(e.version)),
        versionsUsedByComponent: new Map()
      };
    }

    function Et(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "current";
      var n = t.getState(),
          r = "current" === e ? n.currentTree : D(n.previousTree);
      return new St(jt(t, r));
    }

    var At = /*#__PURE__*/function (_St) {
      _inherits(At, _St);

      var _super6 = _createSuper(At);

      function At(t) {
        var _this2;

        _classCallCheck(this, At);

        _this2 = _super6.call(this, jt(t.getStore_INTERNAL(), t.getStore_INTERNAL().getState().currentTree, !0)), u(_assertThisInitialized(_this2), "set", function (t, e) {
          var n = _this2.getStore_INTERNAL();

          mt(n, t, e);
        }), u(_assertThisInitialized(_this2), "reset", function (t) {
          return mt(_this2.getStore_INTERNAL(), t, bt);
        });
        return _this2;
      }

      return At;
    }(St);

    var xt = {
      Snapshot: St,
      MutableSnapshot: At,
      freshSnapshot: function freshSnapshot() {
        return new St(wt());
      },
      cloneSnapshot: Et
    },
        Tt = xt.Snapshot,
        Rt = xt.MutableSnapshot,
        Pt = xt.freshSnapshot,
        kt = xt.cloneSnapshot,
        Mt = Object.freeze({
      __proto__: null,
      Snapshot: Tt,
      MutableSnapshot: Rt,
      freshSnapshot: Pt,
      cloneSnapshot: kt
    });
    var _o$a = o.a,
        Ct = _o$a.useContext,
        Nt = _o$a.useEffect,
        Lt = _o$a.useMemo,
        Dt = _o$a.useRef,
        It = _o$a.useState,
        Vt = C.getDownstreamNodes,
        Bt = C.setNodeValue,
        Ut = C.setUnvalidatedAtomValue,
        Ft = V.graph,
        Wt = V.saveDependencyMapToStore,
        zt = V.cloneGraph,
        $t = rt.applyAtomValueWrites,
        Ht = Mt.freshSnapshot,
        Gt = pt.getNextTreeStateVersion,
        qt = pt.makeEmptyStoreState,
        Xt = E.mapByDeletingMultipleFromMap;

    function Yt() {
      throw new Error("This component must be used inside a <RecoilRoot> component.");
    }

    var Kt = Object.freeze({
      getState: Yt,
      replaceState: Yt,
      getGraph: Yt,
      subscribeToTransactions: Yt,
      addTransactionMetadata: Yt
    });
    var Jt = !1;

    function Qt(t) {
      if (Jt) throw new Error("An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.");

      if (null === t.nextTree) {
        var _e4 = t.currentTree.version,
            _n4 = Gt();

        t.nextTree = _objectSpread(_objectSpread({}, t.currentTree), {}, {
          version: _n4,
          stateID: _n4,
          dirtyAtoms: new Set(),
          transactionMetadata: {}
        }), t.graphsByVersion.set(_n4, zt(D(t.graphsByVersion.get(_e4))));
      }
    }

    var Zt = o.a.createContext({
      current: Kt
    }),
        te = function te() {
      return Ct(Zt);
    },
        ee = o.a.createContext(null);

    function ne(t) {
      var e = t.getState(),
          n = e.currentTree,
          r = n.dirtyAtoms;

      if (r.size) {
        var _iterator9 = _createForOfIteratorHelper(e.nodeTransactionSubscriptions),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var _step9$value = _slicedToArray(_step9.value, 2),
                _n5 = _step9$value[0],
                _o4 = _step9$value[1];

            if (r.has(_n5)) {
              var _iterator12 = _createForOfIteratorHelper(_o4),
                  _step12;

              try {
                for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                  var _step12$value = _slicedToArray(_step12.value, 2),
                      _e5 = _step12$value[0],
                      _n6 = _step12$value[1];

                  _n6(t);
                }
              } catch (err) {
                _iterator12.e(err);
              } finally {
                _iterator12.f();
              }
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }

        var _iterator10 = _createForOfIteratorHelper(e.transactionSubscriptions),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _step10$value = _slicedToArray(_step10.value, 2),
                _n7 = _step10$value[0],
                _r5 = _step10$value[1];

            _r5(t);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }

        var _o3 = Vt(t, n, r);

        var _iterator11 = _createForOfIteratorHelper(_o3),
            _step11;

        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var _t8 = _step11.value;

            var _r6 = e.nodeToComponentSubscriptions.get(_t8);

            if (_r6) {
              var _iterator13 = _createForOfIteratorHelper(_r6),
                  _step13;

              try {
                for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                  var _step13$value = _slicedToArray(_step13.value, 2),
                      _t9 = _step13$value[0],
                      _step13$value$ = _slicedToArray(_step13$value[1], 2),
                      _e6 = _step13$value$[0],
                      _o5 = _step13$value$[1];

                  _o5(n);
                }
              } catch (err) {
                _iterator13.e(err);
              } finally {
                _iterator13.f();
              }
            }
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }

        var _a3 = "[available in dev build]";
        e.suspendedComponentResolvers.forEach(function (t) {
          return B("value became available, waking components", _a3, t);
        });
      }

      e.queuedComponentCallbacks_DEPRECATED.forEach(function (t) {
        return t(n);
      }), e.queuedComponentCallbacks_DEPRECATED.splice(0, e.queuedComponentCallbacks_DEPRECATED.length);
    }

    function re(t) {
      var e = te(),
          _It = It([]),
          _It2 = _slicedToArray(_It, 2),
          n = _It2[0],
          r = _It2[1];

      return t.setNotifyBatcherOfChange(function () {
        return r({});
      }), Nt(function () {
        j("Batcher", function () {
          var t = e.current.getState(),
              n = t.nextTree;
          if (null === n) return;
          t.previousTree = t.currentTree, t.currentTree = n, t.nextTree = null, ne(e.current);
          var r = D(t.previousTree).version;
          t.graphsByVersion.delete(r), t.previousTree = null;
        });
      }), null;
    }

    var oe = 0;
    var ae,
        ie = {
      useStoreRef: te,
      useRecoilMutableSource: function useRecoilMutableSource() {
        return Ct(ee);
      },
      RecoilRoot: function RecoilRoot(_ref10) {
        var t = _ref10.initializeState_DEPRECATED,
            e = _ref10.initializeState,
            n = _ref10.store_INTERNAL,
            r = _ref10.children;
        var a;
        var i;
        var u = Dt(null),
            c = null !== (a = o.a.createMutableSource) && void 0 !== a ? a : o.a.unstable_createMutableSource,
            s = null != n ? n : {
          getState: function getState() {
            return i.current;
          },
          replaceState: function replaceState(t) {
            var e = l.current.getState();
            Qt(e);
            var n = D(e.nextTree);
            var r;

            try {
              Jt = !0, r = t(n);
            } finally {
              Jt = !1;
            }

            r !== n && (e.nextTree = r, D(u.current)());
          },
          getGraph: function getGraph(t) {
            var e = i.current.graphsByVersion;
            if (e.has(t)) return D(e.get(t));
            var n = Ft();
            return e.set(t, n), n;
          },
          subscribeToTransactions: function subscribeToTransactions(t, e) {
            if (null == e) {
              var _l$current$getState = l.current.getState(),
                  _e7 = _l$current$getState.transactionSubscriptions,
                  _n8 = oe++;

              return _e7.set(_n8, t), {
                release: function release() {
                  _e7.delete(_n8);
                }
              };
            }

            {
              var _l$current$getState2 = l.current.getState(),
                  _n9 = _l$current$getState2.nodeTransactionSubscriptions;

              _n9.has(e) || _n9.set(e, new Map());

              var _r7 = oe++;

              return D(_n9.get(e)).set(_r7, t), {
                release: function release() {
                  var t = _n9.get(e);

                  t && (t.delete(_r7), 0 === t.size && _n9.delete(e));
                }
              };
            }
          },
          addTransactionMetadata: function addTransactionMetadata(t) {
            Qt(l.current.getState());

            for (var _i4 = 0, _Object$keys = Object.keys(t); _i4 < _Object$keys.length; _i4++) {
              var _e8 = _Object$keys[_i4];
              D(l.current.getState().nextTree).transactionMetadata[_e8] = t[_e8];
            }
          }
        },
            l = Dt(s);
        i = Dt(null != t ? function (t, e) {
          var n = qt();
          return e({
            set: function set(e, r) {
              var o = n.currentTree,
                  _Bt = Bt(t, o, e.key, r),
                  _Bt2 = _slicedToArray(_Bt, 2),
                  a = _Bt2[0],
                  i = _Bt2[1],
                  u = new Set(i.keys());

              Wt(a, t, o.version);
              var c = Xt(o.nonvalidatedAtoms, u);
              n.currentTree = _objectSpread(_objectSpread({}, o), {}, {
                dirtyAtoms: F(o.dirtyAtoms, u),
                atomValues: $t(o.atomValues, i),
                nonvalidatedAtoms: c
              });
            },
            setUnvalidatedAtomValues: function setUnvalidatedAtomValues(t) {
              t.forEach(function (t, e) {
                n.currentTree = Ut(n.currentTree, e, t);
              });
            }
          }), n;
        }(s, t) : null != e ? function (t) {
          return Ht().map(t).getStore_INTERNAL().getState();
        }(e) : qt());
        var f = Lt(function () {
          return c ? c(i, function () {
            return i.current.currentTree.version;
          }) : null;
        }, [c, i]);
        return o.a.createElement(Zt.Provider, {
          value: l
        }, o.a.createElement(ee.Provider, {
          value: f
        }, o.a.createElement(re, {
          setNotifyBatcherOfChange: function setNotifyBatcherOfChange(t) {
            u.current = t;
          }
        }), r));
      },
      sendEndOfBatchNotifications_FOR_TESTING: ne
    };
    var _o$a2 = o.a,
        ue = _o$a2.useCallback,
        ce = _o$a2.useEffect,
        se = _o$a2.useMemo,
        le = _o$a2.useRef,
        fe = _o$a2.useState,
        pe = S.DEFAULT_VALUE,
        de = S.getNode,
        he = S.nodes,
        ve = ie.useRecoilMutableSource,
        be = ie.useStoreRef,
        ye = b.isRecoilValue,
        ge = rt.AbstractRecoilValue,
        me = rt.getRecoilValueAsLoadable,
        _e = rt.setRecoilValue,
        we = rt.setRecoilValueLoadable,
        Oe = rt.setUnvalidatedRecoilValue,
        Se = rt.subscribeToRecoilValue,
        je = Mt.Snapshot,
        Ee = Mt.cloneSnapshot,
        Ae = E.setByAddingToSet;

    function xe(t, e, n) {
      if ("hasValue" === t.state) return t.contents;
      if ("loading" === t.state) throw new Promise(function (t) {
        n.current.getState().suspendedComponentResolvers.add(t);
      });
      throw "hasError" === t.state ? t.contents : new Error("Invalid value of loadable atom \"".concat(e.key, "\""));
    }

    var Te = null !== (ae = o.a.useMutableSource) && void 0 !== ae ? ae : o.a.unstable_useMutableSource;

    function Re(t) {
      return !Te || "undefined" != typeof window && window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE ? function (t) {
        var e = be(),
            _fe = fe([]),
            _fe2 = _slicedToArray(_fe, 2),
            n = _fe2[0],
            r = _fe2[1];

        return ce(function () {
          var n = e.current,
              o = Se(n, t, function (e) {
            B("RecoilValue subscription fired", t.key, function () {
              r([]);
            });
          });
          return B("initial update on subscribing", t.key, function () {
            n.getState().nextTree ? n.getState().queuedComponentCallbacks_DEPRECATED.push(U(function () {
              r([]);
            })) : r([]);
          }), function () {
            return o.release(n);
          };
        }, [t, e]), me(e.current, t);
      }(t) : function (t) {
        var e = be(),
            n = ue(function () {
          return me(e.current, t, e.current.getState().currentTree);
        }, [e, t]),
            r = ue(function (n, r) {
          var o = e.current,
              a = Se(o, t, function () {
            B("RecoilValue subscription fired", t.key, function () {
              r();
            });
          });
          return function () {
            return a.release(o);
          };
        }, [t, e]);
        return Te(ve(), n, r);
      }(t);
    }

    function Pe(t) {
      var e = be();
      return xe(Re(t), t, e);
    }

    function ke(t) {
      var e = be();
      return ue(function (n) {
        _e(e.current, t, n);
      }, [e, t]);
    }

    function Me(t) {
      var e = be();
      ce(function () {
        return e.current.subscribeToTransactions(t).release;
      }, [t, e]);
    }

    function Ce(t) {
      var e = t.atomValues,
          n = L(function (t, e) {
        var n = new Map();

        var _iterator14 = _createForOfIteratorHelper(t),
            _step14;

        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var _step14$value = _slicedToArray(_step14.value, 2),
                _r8 = _step14$value[0],
                _o6 = _step14$value[1];

            e(_o6, _r8) && n.set(_r8, _o6);
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }

        return n;
      }(e, function (t, e) {
        var n = de(e).persistence_UNSTABLE;
        return null != n && "none" !== n.type && "hasValue" === t.state;
      }), function (t) {
        return t.contents;
      });
      return function () {
        var e = new Map();

        for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          t[_key3] = arguments[_key3];
        }

        for (var _n10 = 0; _n10 < t.length; _n10++) {
          var _r9 = t[_n10].keys();

          var _o7 = void 0;

          for (; !(_o7 = _r9.next()).done;) {
            e.set(_o7.value, t[_n10].get(_o7.value));
          }
        }

        return e;
      }(t.nonvalidatedAtoms, n);
    }

    function Ne() {
      var t = be();
      return ue(function (e) {
        var n;
        var r = t.current.getState(),
            o = null !== (n = r.nextTree) && void 0 !== n ? n : r.currentTree,
            a = e.getStore_INTERNAL().getState().currentTree;
        i.a.unstable_batchedUpdates(function () {
          var n = new Set();

          for (var _i5 = 0, _arr = [o.atomValues.keys(), a.atomValues.keys()]; _i5 < _arr.length; _i5++) {
            var _t10 = _arr[_i5];

            var _iterator15 = _createForOfIteratorHelper(_t10),
                _step15;

            try {
              for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                var _e9 = _step15.value;
                var r, i;
                (null === (r = o.atomValues.get(_e9)) || void 0 === r ? void 0 : r.contents) !== (null === (i = a.atomValues.get(_e9)) || void 0 === i ? void 0 : i.contents) && de(_e9).shouldRestoreFromSnapshots && n.add(_e9);
              }
            } catch (err) {
              _iterator15.e(err);
            } finally {
              _iterator15.f();
            }
          }

          n.forEach(function (e) {
            we(t.current, new ge(e), a.atomValues.has(e) ? D(a.atomValues.get(e)) : pe);
          }), t.current.replaceState(function (t) {
            return _objectSpread(_objectSpread({}, t), {}, {
              stateID: e.getID_INTERNAL()
            });
          });
        });
      }, [t]);
    }

    var Le = function Le() {
      _classCallCheck(this, Le);
    };

    var De = new Le();
    var Ie = {
      recoilComponentGetRecoilValueCount_FOR_TESTING: {
        current: 0
      },
      useGotoRecoilSnapshot: Ne,
      useRecoilCallback: function useRecoilCallback(t, e) {
        var n = be(),
            r = Ne();
        return ue(function () {
          for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            e[_key4] = arguments[_key4];
          }

          var o = Ee(n.current);

          function a(t, e) {
            _e(n.current, t, e);
          }

          function u(t) {
            _e(n.current, t, pe);
          }

          var c = De;
          return i.a.unstable_batchedUpdates(function () {
            c = t({
              set: a,
              reset: u,
              snapshot: o,
              gotoSnapshot: r
            }).apply(void 0, e);
          }), c instanceof Le && function (t, e) {
            if (!t) throw new Error(e);
          }(!1), c;
        }, null != e ? [].concat(_toConsumableArray(e), [n]) : void 0);
      },
      useRecoilInterface: function useRecoilInterface() {
        var t = be(),
            _fe3 = fe([]),
            _fe4 = _slicedToArray(_fe3, 2),
            e = _fe4[0],
            n = _fe4[1],
            r = le(new Set());

        r.current = new Set();
        var o = le(new Set()),
            a = le(new Map()),
            i = ue(function (e) {
          var n = a.current.get(e);
          n && (n.release(t.current), a.current.delete(e));
        }, [t, a]);
        return ce(function () {
          var e = t.current;

          function u(t, e) {
            a.current.has(e) && n([]);
          }

          N(r.current, o.current).forEach(function (t) {
            if (a.current.has(t)) return;
            var n = Se(e, new ge(t), function (e) {
              B("RecoilValue subscription fired", t, function () {
                u(0, t);
              });
            });
            a.current.set(t, n), B("initial update on subscribing", t, function () {
              e.getState().nextTree ? e.getState().queuedComponentCallbacks_DEPRECATED.push(U(function () {
                u(e.getState(), t);
              })) : u(e.getState(), t);
            });
          }), N(o.current, r.current).forEach(function (t) {
            i(t);
          }), o.current = r.current;
        }), ce(function () {
          var t = a.current;
          return function () {
            return t.forEach(function (t, e) {
              return i(e);
            });
          };
        }, [i]), se(function () {
          function e(e) {
            return function (n) {
              _e(t.current, e, n);
            };
          }

          function n(e) {
            return r.current.has(e.key) || (r.current = Ae(r.current, e.key)), me(t.current, e);
          }

          function o(e) {
            return xe(n(e), e, t);
          }

          return {
            getRecoilValue: o,
            getRecoilValueLoadable: n,
            getRecoilState: function getRecoilState(t) {
              return [o(t), e(t)];
            },
            getRecoilStateLoadable: function getRecoilStateLoadable(t) {
              return [n(t), e(t)];
            },
            getSetRecoilState: e,
            getResetRecoilState: function getResetRecoilState(e) {
              return function () {
                return _e(t.current, e, pe);
              };
            }
          };
        }, [r, t]);
      },
      useRecoilSnapshot: function useRecoilSnapshot() {
        var t = be(),
            _fe5 = fe(function () {
          return Ee(t.current);
        }),
            _fe6 = _slicedToArray(_fe5, 2),
            e = _fe6[0],
            n = _fe6[1];

        return Me(ue(function (t) {
          return n(Ee(t));
        }, [])), e;
      },
      useRecoilState: function useRecoilState(t) {
        return [Pe(t), ke(t)];
      },
      useRecoilStateLoadable: function useRecoilStateLoadable(t) {
        return [Re(t), ke(t)];
      },
      useRecoilTransactionObserver: function useRecoilTransactionObserver(t) {
        Me(ue(function (e) {
          t({
            snapshot: Ee(e, "current"),
            previousSnapshot: Ee(e, "previous")
          });
        }, [t]));
      },
      useRecoilValue: Pe,
      useRecoilValueLoadable: Re,
      useResetRecoilState: function useResetRecoilState(t) {
        var e = be();
        return ue(function () {
          _e(e.current, t, pe);
        }, [e, t]);
      },
      useSetRecoilState: ke,
      useSetUnvalidatedAtomValues: function useSetUnvalidatedAtomValues() {
        var t = be();
        return function (e) {
          var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          i.a.unstable_batchedUpdates(function () {
            t.current.addTransactionMetadata(n), e.forEach(function (e, n) {
              return Oe(t.current, new ge(n), e);
            });
          });
        };
      },
      useTransactionObservation_DEPRECATED: function useTransactionObservation_DEPRECATED(t) {
        Me(ue(function (e) {
          var n = e.getState().previousTree;
          var r = e.getState().currentTree;
          n || (n = e.getState().currentTree);

          var o = Ce(r),
              a = Ce(n),
              i = L(he, function (t) {
            var e, n, r, o;
            return {
              persistence_UNSTABLE: {
                type: null !== (e = null === (n = t.persistence_UNSTABLE) || void 0 === n ? void 0 : n.type) && void 0 !== e ? e : "none",
                backButton: null !== (r = null === (o = t.persistence_UNSTABLE) || void 0 === o ? void 0 : o.backButton) && void 0 !== r && r
              }
            };
          }),
              u = function (t, e) {
            var n = new Set();

            var _iterator16 = _createForOfIteratorHelper(t),
                _step16;

            try {
              for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                var _r10 = _step16.value;
                e(_r10) && n.add(_r10);
              }
            } catch (err) {
              _iterator16.e(err);
            } finally {
              _iterator16.f();
            }

            return n;
          }(r.dirtyAtoms, function (t) {
            return o.has(t) || a.has(t);
          });

          t({
            atomValues: o,
            previousAtomValues: a,
            atomInfo: i,
            modifiedAtoms: u,
            transactionMetadata: _objectSpread({}, r.transactionMetadata)
          });
        }, [t]));
      },
      useTransactionSubscription_DEPRECATED: Me
    };
    var Ve = o.a.useMemo,
        Be = ie.RecoilRoot,
        Ue = ie.useStoreRef;

    var Fe = function Fe(t) {
      return !!t && "function" == typeof t.then;
    };

    var We = {
      getValue: function getValue() {
        if ("hasValue" !== this.state) throw this.contents;
        return this.contents;
      },
      toPromise: function toPromise() {
        return "hasValue" === this.state ? Promise.resolve(this.contents) : "hasError" === this.state ? Promise.reject(this.contents) : this.contents;
      },
      valueMaybe: function valueMaybe() {
        return "hasValue" === this.state ? this.contents : void 0;
      },
      valueOrThrow: function valueOrThrow() {
        if ("hasValue" !== this.state) throw new Error("Loadable expected value, but in \"".concat(this.state, "\" state"));
        return this.contents;
      },
      errorMaybe: function errorMaybe() {
        return "hasError" === this.state ? this.contents : void 0;
      },
      errorOrThrow: function errorOrThrow() {
        if ("hasError" !== this.state) throw new Error("Loadable expected error, but in \"".concat(this.state, "\" state"));
        return this.contents;
      },
      promiseMaybe: function promiseMaybe() {
        return "loading" === this.state ? this.contents : void 0;
      },
      promiseOrThrow: function promiseOrThrow() {
        if ("loading" !== this.state) throw new Error("Loadable expected promise, but in \"".concat(this.state, "\" state"));
        return this.contents;
      },
      map: function map(t) {
        var _this3 = this;

        if ("hasError" === this.state) return this;
        if ("hasValue" === this.state) try {
          var _e10 = t(this.contents);

          return Fe(_e10) ? He(_e10) : ze(_e10);
        } catch (e) {
          return Fe(e) ? He(e.next(function () {
            return t(_this3.contents);
          })) : $e(e);
        }
        if ("loading" === this.state) return He(this.contents.then(t).catch(function (e) {
          if (Fe(e)) return e.then(function () {
            return t(_this3.contents);
          });
          throw e;
        }));
        throw new Error("Invalid Loadable state");
      }
    };

    function ze(t) {
      return Object.freeze(_objectSpread({
        state: "hasValue",
        contents: t
      }, We));
    }

    function $e(t) {
      return Object.freeze(_objectSpread({
        state: "hasError",
        contents: t
      }, We));
    }

    function He(t) {
      return Object.freeze(_objectSpread({
        state: "loading",
        contents: t
      }, We));
    }

    var Ge = {
      loadableWithValue: ze,
      loadableWithError: $e,
      loadableWithPromise: He,
      loadableLoading: function loadableLoading() {
        return He(new Promise(function () {}));
      },
      loadableAll: function loadableAll(t) {
        return t.every(function (t) {
          return "hasValue" === t.state;
        }) ? ze(t.map(function (t) {
          return t.contents;
        })) : t.some(function (t) {
          return "hasError" === t.state;
        }) ? $e(D(t.find(function (t) {
          return "hasError" === t.state;
        }), "Invalid loadable passed to loadableAll").contents) : He(ut("recoil_async_selector_refactor") ? Promise.all(t.map(function (t) {
          return t.contents;
        })).then(function (t) {
          return {
            value: t
          };
        }) : Promise.all(t.map(function (t) {
          return t.contents;
        })));
      }
    };
    var qe = Symbol("ArrayKeyedMap"),
        Xe = new Map();

    var Ye = /*#__PURE__*/function () {
      function Ye(t) {
        _classCallCheck(this, Ye);

        if (this._base = new Map(), t instanceof Ye) {
          var _iterator17 = _createForOfIteratorHelper(t.entries()),
              _step17;

          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              var _step17$value = _slicedToArray(_step17.value, 2),
                  _e11 = _step17$value[0],
                  _n11 = _step17$value[1];

              this.set(_e11, _n11);
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }
        } else if (t) {
          var _iterator18 = _createForOfIteratorHelper(t),
              _step18;

          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var _step18$value = _slicedToArray(_step18.value, 2),
                  _e12 = _step18$value[0],
                  _n12 = _step18$value[1];

              this.set(_e12, _n12);
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }
        }

        return this;
      }

      _createClass(Ye, [{
        key: "get",
        value: function get(t) {
          var e = Array.isArray(t) ? t : [t];
          var n = this._base;
          return e.forEach(function (t) {
            var e;
            n = null !== (e = n.get(t)) && void 0 !== e ? e : Xe;
          }), void 0 === n ? void 0 : n.get(qe);
        }
      }, {
        key: "set",
        value: function set(t, e) {
          var n = Array.isArray(t) ? t : [t];
          var r = this._base,
              o = r;
          return n.forEach(function (t) {
            o = r.get(t), o || (o = new Map(), r.set(t, o)), r = o;
          }), o.set(qe, e), this;
        }
      }, {
        key: "delete",
        value: function _delete(t) {
          var e = Array.isArray(t) ? t : [t];
          var n = this._base,
              r = n;
          return e.forEach(function (t) {
            r = n.get(t), r || (r = new Map(), n.set(t, r)), n = r;
          }), r.delete(qe), this;
        }
      }, {
        key: "entries",
        value: function entries() {
          var t = [];
          return function e(n, r) {
            n.forEach(function (n, o) {
              o === qe ? t.push([r, n]) : e(n, r.concat(o));
            });
          }(this._base, []), t.values();
        }
      }, {
        key: "toBuiltInMap",
        value: function toBuiltInMap() {
          return new Map(this.entries());
        }
      }]);

      return Ye;
    }();

    var Ke = Ye,
        Je = function Je() {
      return new Ke();
    };

    var Qe = Ge.loadableWithError,
        Ze = Ge.loadableWithPromise,
        tn = Ge.loadableWithValue,
        en = C.getNodeLoadable,
        nn = C.peekNodeLoadable,
        rn = C.setNodeValue,
        on = V.addToDependencyMap,
        an = V.mergeDepsIntoDependencyMap,
        un = V.saveDependencyMapToStore,
        cn = S.DEFAULT_VALUE,
        sn = S.RecoilValueNotReady,
        ln = S.registerNode,
        fn = b.AbstractRecoilValue,
        pn = rt.getRecoilValueAsLoadable,
        dn = rt.isRecoilValue,
        hn = rt.setRecoilValueLoadable,
        _startPerfBlock = {
      startPerfBlock: function startPerfBlock(t) {
        return function () {
          return null;
        };
      }
    },
        vn = _startPerfBlock.startPerfBlock,
        bn = Object.freeze(new Set());

    function yn(t) {
      var e = [];

      var _iterator19 = _createForOfIteratorHelper(Array.from(t.keys()).sort()),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var _n13 = _step19.value;

          var _r11 = D(t.get(_n13));

          e.push(_n13), e.push(_r11.state), e.push(_r11.contents);
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }

      return e;
    }

    var gn = new Map();

    var mn = function mn(t) {
      var e = t.key,
          n = t.get,
          r = t.cacheImplementation_UNSTABLE,
          o = null != t.set ? t.set : void 0;
      var a = null != r ? r : Je();

      function i(t) {
        t.getState().knownSelectors.add(e);
      }

      function u(t, e) {
        if ("loading" === e.state) {
          var _n14 = gn.get(e);

          void 0 === _n14 && gn.set(e, _n14 = new Set()), _n14.add(t);
        }
      }

      function c(t, n) {
        var r = gn.get(t);

        if (void 0 !== r) {
          var _iterator20 = _createForOfIteratorHelper(r),
              _step20;

          try {
            for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
              var _t11 = _step20.value;
              hn(_t11, new fn(e), n);
            }
          } catch (err) {
            _iterator20.e(err);
          } finally {
            _iterator20.f();
          }

          gn.delete(t);
        }
      }

      function s(t, r) {
        var o;
        var i = new Map(),
            s = null !== (o = t.getGraph(r.version).nodeDeps.get(e)) && void 0 !== o ? o : bn,
            l = yn(new Map(Array.from(s).sort().map(function (e) {
          var _en = en(t, r, e),
              _en2 = _slicedToArray(_en, 2),
              n = _en2[0],
              o = _en2[1];

          return an(n, i), un(i, t, r.version), [e, o];
        }))),
            f = a.get(l);
        if (null != f) return u(t, f), [i, f];

        var _ref11 = function (t, r) {
          var o = vn(e),
              a = new Map(),
              i = new Map();

          function u(_ref13) {
            var n = _ref13.key;
            on(e, n, i);

            var _en3 = en(t, r, n),
                _en4 = _slicedToArray(_en3, 2),
                o = _en4[0],
                u = _en4[1];

            if (a.set(n, u), an(o, i), un(i, t, r.version), "hasValue" === u.state) return u.contents;
            throw u.contents;
          }

          try {
            var _t12 = n({
              get: u
            }),
                _e13 = dn(_t12) ? u(_t12) : _t12;

            var _r12;

            return Fe(_e13) ? _r12 = Ze(_e13.finally(o)) : (o(), _r12 = tn(_e13)), [i, _r12, a];
          } catch (n) {
            var _r13;

            return void 0 !== n.then ? _r13 = Ze(n.then(function () {
              var n = pn(t, new fn(e));
              if ("hasError" === n.state) throw n.contents;
              return n.contents;
            }).finally(o)) : (o(), _r13 = Qe(n)), [i, _r13, a];
          }
        }(t, r),
            _ref12 = _slicedToArray(_ref11, 3),
            p = _ref12[0],
            d = _ref12[1],
            h = _ref12[2];

        an(p, i), un(i, t, r.version);
        var v = yn(h);
        return u(t, d), function (t, e) {
          "loading" !== e.state || e.contents.then(function (n) {
            var r = tn(n);
            return a = a.set(t, r), c(e, r), n;
          }).catch(function (n) {
            if (Fe(n)) return n;
            var r = Qe(n);
            return a = a.set(t, r), c(e, r), n;
          }), a = a.set(t, e);
        }(v, d), [i, d];
      }

      function l(t, n) {
        var r;
        var o = null !== (r = t.getGraph(n.version).nodeDeps.get(e)) && void 0 !== r ? r : bn,
            i = new Map(Array.from(o).sort().map(function (e) {
          return [e, nn(t, n, e)];
        })),
            u = new Map();

        var _iterator21 = _createForOfIteratorHelper(i.entries()),
            _step21;

        try {
          for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
            var _step21$value = _slicedToArray(_step21.value, 2),
                _t13 = _step21$value[0],
                _e14 = _step21$value[1];

            if (null == _e14) return;
            u.set(_t13, _e14);
          }
        } catch (err) {
          _iterator21.e(err);
        } finally {
          _iterator21.f();
        }

        var c = yn(u);
        return a.get(c);
      }

      function f(t, e) {
        return i(t), s(t, e);
      }

      return ln(null != o ? {
        key: e,
        peek: l,
        get: f,
        set: function set(t, e, n) {
          i(t);
          var r = new Map(),
              a = new Map();

          function u(_ref14) {
            var n = _ref14.key;

            var _en5 = en(t, e, n),
                _en6 = _slicedToArray(_en5, 2),
                o = _en6[0],
                a = _en6[1];

            if (an(o, r), "hasValue" === a.state) return a.contents;
            throw "loading" === a.state ? new sn(n) : a.contents;
          }

          function c(n, o) {
            var i = "function" == typeof o ? o(u(n)) : o,
                _rn = rn(t, e, n.key, i),
                _rn2 = _slicedToArray(_rn, 2),
                c = _rn2[0],
                s = _rn2[1];

            an(c, r), s.forEach(function (t, e) {
              return a.set(e, t);
            });
          }

          return o({
            set: c,
            get: u,
            reset: function reset(t) {
              c(t, cn);
            }
          }, n), [r, a];
        },
        dangerouslyAllowMutability: t.dangerouslyAllowMutability,
        shouldRestoreFromSnapshots: !1
      } : {
        key: e,
        peek: l,
        get: f,
        dangerouslyAllowMutability: t.dangerouslyAllowMutability,
        shouldRestoreFromSnapshots: !1
      });
    };

    var _n = Ge.loadableWithError,
        wn = Ge.loadableWithPromise,
        On = Ge.loadableWithValue,
        Sn = S.DEFAULT_VALUE,
        jn = S.DefaultValue,
        En = S.registerNode,
        An = b.isRecoilValue,
        xn = rt.markRecoilValueModified,
        Tn = rt.setRecoilValue,
        Rn = rt.setRecoilValueLoadable;

    var Pn = function t(e) {
      var n = e.default,
          r = _objectWithoutProperties(e, _excluded);

      return An(n) ? function (e) {
        var n = t(_objectSpread(_objectSpread({}, e), {}, {
          default: Sn,
          persistence_UNSTABLE: void 0 === e.persistence_UNSTABLE ? void 0 : _objectSpread(_objectSpread({}, e.persistence_UNSTABLE), {}, {
            validator: function validator(t) {
              return t instanceof jn ? t : D(e.persistence_UNSTABLE).validator(t, Sn);
            }
          }),
          effects_UNSTABLE: e.effects_UNSTABLE
        }));
        return mn({
          key: e.key + "__withFallback",
          get: function get(_ref15) {
            var t = _ref15.get;
            var r = t(n);
            return r instanceof jn ? e.default : r;
          },
          set: function set(_ref16, e) {
            var t = _ref16.set;
            return t(n, e);
          },
          dangerouslyAllowMutability: e.dangerouslyAllowMutability
        });
      }(_objectSpread(_objectSpread({}, r), {}, {
        default: n
      })) : function (t) {
        var e = t.key,
            n = t.persistence_UNSTABLE;
        var r = Fe(t.default) ? wn(t.default.then(function (t) {
          return r = On(t), t;
        }).catch(function (t) {
          throw r = _n(t), t;
        })) : On(t.default),
            o = void 0;

        function a(n, o, a) {
          if (n.getState().knownAtoms.has(e)) return;

          if (n.getState().knownAtoms.add(e), "loading" === r.state) {
            var _u = function _u() {
              var t;
              (null !== (t = n.getState().nextTree) && void 0 !== t ? t : n.getState().currentTree).atomValues.has(e) || xn(n, i);
            };

            r.contents.then(_u).catch(_u);
          }

          var c = Sn;

          if (null != t.effects_UNSTABLE) {
            var _s = function _s(t) {
              if (_o8) {
                var _e15 = c instanceof jn || Fe(c) ? "hasValue" === r.state ? r.contents : Sn : c;

                c = "function" == typeof t ? t(_e15) : t;
              } else {
                if (Fe(t)) throw new Error("Setting atoms to async values is not implemented.");
                Tn(n, i, t);
              }
            };

            var _l = function _l(t) {
              n.subscribeToTransactions(function (n) {
                var _n$getState = n.getState(),
                    o = _n$getState.currentTree,
                    a = _n$getState.previousTree;

                a || (a = o);
                var i = o.atomValues.get(e);

                if (null == i || "hasValue" === i.state) {
                  var u;

                  var _n15 = null != i ? i.contents : Sn,
                      _o9 = null !== (u = a.atomValues.get(e)) && void 0 !== u ? u : r,
                      _c3 = "hasValue" === _o9.state ? _o9.contents : Sn;

                  t(_n15, _c3);
                }
              }, e);
            };

            var _o8 = !0;

            var _u2 = function _u2() {
              return _s(Sn);
            };

            var _iterator22 = _createForOfIteratorHelper(null !== (f = t.effects_UNSTABLE) && void 0 !== f ? f : []),
                _step22;

            try {
              for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                var _e16 = _step22.value;
                var f;

                _e16({
                  node: i,
                  trigger: a,
                  setSelf: _s,
                  resetSelf: _u2,
                  onSet: _l
                });
              }
            } catch (err) {
              _iterator22.e(err);
            } finally {
              _iterator22.f();
            }

            _o8 = !1;
          }

          c instanceof jn || o.atomValues.set(e, Fe(c) ? wn(function (t, n) {
            var r = n.then(function (n) {
              var o, a;
              return (null === (a = (null !== (o = t.getState().nextTree) && void 0 !== o ? o : t.getState().currentTree).atomValues.get(e)) || void 0 === a ? void 0 : a.contents) === r && Tn(t, i, n), n;
            }).catch(function (n) {
              var o, a;
              throw (null === (a = (null !== (o = t.getState().nextTree) && void 0 !== o ? o : t.getState().currentTree).atomValues.get(e)) || void 0 === a ? void 0 : a.contents) === r && Rn(t, i, _n(n)), n;
            });
            return r;
          }(n, c)) : On(c));
        }

        var i = En({
          key: e,
          peek: function peek(t, n) {
            var a, i, u;
            return null !== (a = null !== (i = n.atomValues.get(e)) && void 0 !== i ? i : null === (u = o) || void 0 === u ? void 0 : u[1]) && void 0 !== a ? a : r;
          },
          get: function get(t, i) {
            if (a(t, i, "get"), i.atomValues.has(e)) return [new Map(), D(i.atomValues.get(e))];

            if (i.nonvalidatedAtoms.has(e)) {
              if (null != o) return o;
              if (null == n) return [new Map(), r];

              var _t14 = i.nonvalidatedAtoms.get(e),
                  _a4 = n.validator(_t14, Sn),
                  _u3 = _a4 instanceof jn ? r : On(_a4);

              return o = [new Map(), _u3], o;
            }

            return [new Map(), r];
          },
          set: function set(t, n, r) {
            if (a(t, n, "set"), n.atomValues.has(e)) {
              var _t15 = D(n.atomValues.get(e));

              if ("hasValue" === _t15.state && r === _t15.contents) return [new Map(), new Map()];
            } else if (!n.nonvalidatedAtoms.has(e) && r instanceof jn) return [new Map(), new Map()];

            return o = void 0, [new Map(), new Map().set(e, On(r))];
          },
          invalidate: function invalidate() {
            o = void 0;
          },
          dangerouslyAllowMutability: t.dangerouslyAllowMutability,
          persistence_UNSTABLE: t.persistence_UNSTABLE ? {
            type: t.persistence_UNSTABLE.type,
            backButton: t.persistence_UNSTABLE.backButton
          } : void 0,
          shouldRestoreFromSnapshots: !0
        });
        return i;
      }(_objectSpread(_objectSpread({}, r), {}, {
        default: n
      }));
    },
        kn = function kn(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        allowFunctions: !1
      };
      return function t(e, n, r) {
        if ("string" == typeof e && !e.includes('"') && !e.includes("\\")) return "\"".concat(e, "\"");

        switch (typeof e) {
          case "undefined":
            return "";

          case "boolean":
            return e ? "true" : "false";

          case "number":
          case "symbol":
            return String(e);

          case "string":
            return JSON.stringify(e);

          case "function":
            if (!0 !== (null == n ? void 0 : n.allowFunctions)) throw new Error("Attempt to serialize function in a Recoil cache key");
            return "__FUNCTION(".concat(e.name, ")__");
        }

        if (null === e) return "null";
        var o;
        if ("object" != typeof e) return null !== (o = JSON.stringify(e)) && void 0 !== o ? o : "";
        if (Fe(e)) return "__PROMISE__";
        if (Array.isArray(e)) return "[".concat(e.map(function (e, r) {
          return t(e, n, r.toString());
        }), "]");
        if ("function" == typeof e.toJSON) return t(e.toJSON(r), n, r);

        if (e instanceof Map) {
          var _o10 = {};

          var _iterator23 = _createForOfIteratorHelper(e),
              _step23;

          try {
            for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
              var _step23$value = _slicedToArray(_step23.value, 2),
                  _r14 = _step23$value[0],
                  _a5 = _step23$value[1];

              _o10["string" == typeof _r14 ? _r14 : t(_r14, n)] = _a5;
            }
          } catch (err) {
            _iterator23.e(err);
          } finally {
            _iterator23.f();
          }

          return t(_o10, n, r);
        }

        return e instanceof Set ? t(Array.from(e).sort(function (e, r) {
          return t(e, n).localeCompare(t(r, n));
        }), n, r) : null != e[Symbol.iterator] && "function" == typeof e[Symbol.iterator] ? t(Array.from(e), n, r) : "{".concat(Object.keys(e).filter(function (t) {
          return void 0 !== e[t];
        }).sort().map(function (r) {
          return "".concat(t(r, n), ":").concat(t(e[r], n, r));
        }).join(","), "}");
      }(t, e);
    },
        Mn = function Mn() {
      var t = new Map(),
          e = {
        get: function get(e) {
          return t.get(kn(e));
        },
        set: function set(n, r) {
          return t.set(kn(n), r), e;
        },
        map: t
      };
      return e;
    };

    var Cn = 0;

    var Nn = function Nn(t) {
      var e, n;
      var r = null !== (e = null === (n = t.cacheImplementationForParams_UNSTABLE) || void 0 === n ? void 0 : n.call(t)) && void 0 !== e ? e : Mn();
      return function (e) {
        var n, o;
        var a = r.get(e);
        if (null != a) return a;

        var i = "".concat(t.key, "__selectorFamily/").concat(null !== (n = kn(e, {
          allowFunctions: !0
        })) && void 0 !== n ? n : "void", "/").concat(Cn++),
            u = function u(n) {
          return t.get(e)(n);
        },
            c = null === (o = t.cacheImplementation_UNSTABLE) || void 0 === o ? void 0 : o.call(t);

        var s;

        if (null != t.set) {
          var _n16 = t.set;
          s = mn({
            key: i,
            get: u,
            set: function set(t, r) {
              return _n16(e)(t, r);
            },
            cacheImplementation_UNSTABLE: c,
            dangerouslyAllowMutability: t.dangerouslyAllowMutability
          });
        } else s = mn({
          key: i,
          get: u,
          cacheImplementation_UNSTABLE: c,
          dangerouslyAllowMutability: t.dangerouslyAllowMutability
        });

        return r = r.set(e, s), s;
      };
    };

    var Ln = S.DEFAULT_VALUE,
        Dn = S.DefaultValue;
    var In = Nn({
      key: "__constant",
      get: function get(t) {
        return function () {
          return t;
        };
      },
      cacheImplementationForParams_UNSTABLE: Je
    });
    var Vn = Nn({
      key: "__error",
      get: function get(t) {
        return function () {
          throw new Error(t);
        };
      },
      cacheImplementationForParams_UNSTABLE: Je
    });
    var Bn = Ge.loadableWithError,
        Un = Ge.loadableWithPromise,
        Fn = Ge.loadableWithValue;

    function Wn(t, e) {
      var n = Array(e.length).fill(void 0),
          r = Array(e.length).fill(void 0);

      var _iterator24 = _createForOfIteratorHelper(e.entries()),
          _step24;

      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var _step24$value = _slicedToArray(_step24.value, 2),
              _o11 = _step24$value[0],
              _a6 = _step24$value[1];

          try {
            n[_o11] = t(_a6);
          } catch (t) {
            r[_o11] = t;
          }
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }

      return [n, r];
    }

    function zn(t) {
      return null != t && !Fe(t);
    }

    function $n(t) {
      return Array.isArray(t) ? t : Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      });
    }

    function Hn(t) {
      return t.hasOwnProperty("value") ? t.value : t;
    }

    function Gn(t, e) {
      return Array.isArray(t) ? e : Object.getOwnPropertyNames(t).reduce(function (t, n, r) {
        return _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, n, e[r]));
      }, {});
    }

    function qn(t, e, n) {
      return Gn(t, n.map(function (t, n) {
        return null == t ? Fn(e[n]) : Fe(t) ? Un(t) : Bn(t);
      }));
    }

    var Xn = {
      waitForNone: Nn({
        key: "__waitForNone",
        get: function get(t) {
          return function (_ref17) {
            var e = _ref17.get;

            var n = $n(t),
                _Wn = Wn(e, n),
                _Wn2 = _slicedToArray(_Wn, 2),
                r = _Wn2[0],
                o = _Wn2[1];

            return qn(t, r, o);
          };
        }
      }),
      waitForAny: Nn({
        key: "__waitForAny",
        get: function get(t) {
          return function (_ref18) {
            var e = _ref18.get;

            var n = $n(t),
                _Wn3 = Wn(e, n),
                _Wn4 = _slicedToArray(_Wn3, 2),
                r = _Wn4[0],
                o = _Wn4[1];

            if (o.some(function (t) {
              return null == t;
            })) return qn(t, r, o);
            if (o.every(zn)) throw o.find(zn);
            if (ut("recoil_async_selector_refactor")) return new Promise(function (e, n) {
              var _iterator25 = _createForOfIteratorHelper(o.entries()),
                  _step25;

              try {
                var _loop = function _loop() {
                  var _step25$value = _slicedToArray(_step25.value, 2),
                      a = _step25$value[0],
                      i = _step25$value[1];

                  Fe(i) && i.then(function (n) {
                    r[a] = Hn(n), o[a] = null, e(qn(t, r, o));
                  }).catch(function (t) {
                    o[a] = t, o.every(zn) && n(o[0]);
                  });
                };

                for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
                  _loop();
                }
              } catch (err) {
                _iterator25.e(err);
              } finally {
                _iterator25.f();
              }
            });
            throw new Promise(function (e, n) {
              var _iterator26 = _createForOfIteratorHelper(o.entries()),
                  _step26;

              try {
                var _loop2 = function _loop2() {
                  var _step26$value = _slicedToArray(_step26.value, 2),
                      a = _step26$value[0],
                      i = _step26$value[1];

                  Fe(i) && i.then(function (n) {
                    r[a] = n, o[a] = null, e(qn(t, r, o));
                  }).catch(function (t) {
                    o[a] = t, o.every(zn) && n(o[0]);
                  });
                };

                for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                  _loop2();
                }
              } catch (err) {
                _iterator26.e(err);
              } finally {
                _iterator26.f();
              }
            });
          };
        }
      }),
      waitForAll: Nn({
        key: "__waitForAll",
        get: function get(t) {
          return function (_ref19) {
            var e = _ref19.get;

            var n = $n(t),
                _Wn5 = Wn(e, n),
                _Wn6 = _slicedToArray(_Wn5, 2),
                r = _Wn6[0],
                o = _Wn6[1];

            if (o.every(function (t) {
              return null == t;
            })) return Gn(t, r);
            var a = o.find(zn);
            if (null != a) throw a;
            if (ut("recoil_async_selector_refactor")) return Promise.all(o).then(function (e) {
              return Gn(t, e.map(Hn));
            });
            throw Promise.all(o).then(function (e) {
              return Gn(t, e);
            });
          };
        }
      }),
      noWait: Nn({
        key: "__noWait",
        get: function get(t) {
          return function (_ref20) {
            var e = _ref20.get;

            try {
              return Fn(e(t));
            } catch (t) {
              return Fe(t) ? Un(t) : Bn(t);
            }
          };
        }
      })
    };
    var Yn = S.DefaultValue,
        Kn = ie.RecoilRoot,
        Jn = b.isRecoilValue,
        Qn = Ie.useGotoRecoilSnapshot,
        Zn = Ie.useRecoilCallback,
        tr = Ie.useRecoilSnapshot,
        er = Ie.useRecoilState,
        nr = Ie.useRecoilStateLoadable,
        rr = Ie.useRecoilTransactionObserver,
        or = Ie.useRecoilValue,
        ar = Ie.useRecoilValueLoadable,
        ir = Ie.useResetRecoilState,
        ur = Ie.useSetRecoilState,
        cr = Ie.useSetUnvalidatedAtomValues,
        sr = Ie.useTransactionObservation_DEPRECATED,
        lr = Xn.noWait,
        fr = Xn.waitForAll,
        pr = Xn.waitForAny,
        dr = Xn.waitForNone;

    var hr = {
      DefaultValue: Yn,
      RecoilRoot: Kn,
      useRecoilBridgeAcrossReactRoots_UNSTABLE: function useRecoilBridgeAcrossReactRoots_UNSTABLE() {
        var t = Ue().current;
        return Ve(function () {
          return function (_ref21) {
            var e = _ref21.children;
            return o.a.createElement(Be, {
              store_INTERNAL: t
            }, e);
          };
        }, [t]);
      },
      atom: Pn,
      selector: mn,
      atomFamily: function atomFamily(t) {
        var e = Mn();
        var n = {
          key: t.key,
          default: Ln,
          persistence_UNSTABLE: t.persistence_UNSTABLE
        };
        var r;
        r = Pn(n);
        var o = Nn({
          key: t.key + "__atomFamily/Default",
          get: function get(e) {
            return function (_ref22) {
              var n = _ref22.get;
              var o = n("function" == typeof r ? r(e) : r);
              return o instanceof Dn ? "function" == typeof t.default ? t.default(e) : t.default : o;
            };
          },
          dangerouslyAllowMutability: t.dangerouslyAllowMutability
        });
        return function (n) {
          var r;
          var a = e.get(n);
          if (null != a) return a;
          var i = Pn(_objectSpread(_objectSpread({}, t), {}, {
            key: "".concat(t.key, "__").concat(null !== (r = kn(n)) && void 0 !== r ? r : "void"),
            default: o(n),
            effects_UNSTABLE: "function" == typeof t.effects_UNSTABLE ? t.effects_UNSTABLE(n) : t.effects_UNSTABLE
          }));
          return e = e.set(n, i), i;
        };
      },
      selectorFamily: Nn,
      constSelector: function constSelector(t) {
        return In(t);
      },
      errorSelector: function errorSelector(t) {
        return Vn(t);
      },
      readOnlySelector: function readOnlySelector(t) {
        return t;
      },
      useRecoilValue: or,
      useRecoilValueLoadable: ar,
      useRecoilState: er,
      useRecoilStateLoadable: nr,
      useSetRecoilState: ur,
      useResetRecoilState: ir,
      useRecoilCallback: Zn,
      useGotoRecoilSnapshot: Qn,
      useRecoilSnapshot: tr,
      useRecoilTransactionObserver_UNSTABLE: rr,
      useTransactionObservation_UNSTABLE: sr,
      useSetUnvalidatedAtomValues_UNSTABLE: cr,
      noWait: lr,
      waitForNone: dr,
      waitForAny: pr,
      waitForAll: fr,
      isRecoilValue: Jn
    },
        vr = hr.RecoilRoot,
        br = hr.atom,
        yr = hr.selector,
        gr = hr.useRecoilValue,
        mr = hr.useRecoilState,
        _r = hr.useSetRecoilState,
        wr = n(17),
        Or = n.n(wr),
        Sr = n(100),
        jr = n.n(Sr),
        Er = n(1),
        Ar = br({
      key: "@brainhubeu/react-carousel/slideMovementState",
      default: {
        clicked: null,
        dragStart: null,
        dragEnd: null,
        dragOffset: 0
      }
    }),
        xr = br({
      key: "@brainhubeu/react-carousel/transitionEnabledState",
      default: !1
    }),
        Tr = br({
      key: "@brainhubeu/react-carousel/trackWidthState",
      default: 0
    }),
        Rr = br({
      key: "@brainhubeu/react-carousel/trackStylesState",
      default: {
        marginLeft: 0,
        transform: 0
      }
    }),
        Pr = br({
      key: "@brainhubeu/react-carousel/carouselStrategiesState",
      default: []
    }),
        kr = br({
      key: "@brainhubeu/react-carousel/carouselValueState",
      default: 0
    }),
        Mr = n(18),
        Cr = n.n(Mr),
        Nr = n(19),
        Lr = n.n(Nr),
        Dr = function Dr(t, e) {
      var n = (e || []).length - 1;
      return t > n ? n : t < 0 ? 0 : t;
    },
        Ir = "CHANGE_SLIDE",
        Vr = "GET_CURRENT_VALUE",
        Br = "GET_TRANSFORM_OFFSET",
        Ur = "GET_NEAREST_SLIDE",
        Fr = br({
      key: "@brainhubeu/react-carousel/activeSlideIndexState",
      default: 0
    }),
        Wr = br({
      key: "@brainhubeu/react-carousel/itemWidthState",
      default: 0
    }),
        zr = br({
      key: "@brainhubeu/react-carousel/itemOffsetState",
      default: 0
    }),
        $r = br({
      key: "@brainhubeu/react-carousel/slidesState",
      default: []
    });

    function Hr(t) {
      return function (t) {
        if (Array.isArray(t)) return Gr(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
      }(t) || function (t, e) {
        if (t) {
          if ("string" == typeof t) return Gr(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Gr(t, e) : void 0;
        }
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Gr(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    var qr = yr({
      key: "@brainhubeu/react-carousel/getCurrentSlideSelector",
      get: function get(t) {
        var e = t.get,
            n = e(kr),
            r = e($r),
            o = function o() {
          return Dr(n, r);
        },
            a = e(Pr).map(function (t) {
          return t && t[Vr];
        }).filter(function (t) {
          return "function" == typeof t;
        });

        return a.map(function (t) {
          return Lr()(t, null, n);
        }).length ? Cr()([o].concat(Hr(a)))() : o();
      },
      set: function set(t, e) {
        var n = t.set,
            r = t.get,
            o = r($r),
            a = function a() {
          return Dr(e, o);
        },
            i = r(Pr).map(function (t) {
          return t && t[Ir];
        }).filter(function (t) {
          return "function" == typeof t;
        }),
            u = i.map(function (t) {
          return Lr()(t, null, e);
        }),
            c = i.length ? Cr()([a].concat(Hr(u)))() : a();

        n(kr, c);
      }
    }),
        Xr = yr({
      key: "@brainhubeu/react-carousel/transformOffsetSelector",
      get: function get(t) {
        var e = t.get,
            n = e(Wr),
            r = e(zr),
            o = e(Ar).dragOffset,
            a = e(kr),
            i = function i() {
          return o - a * (n + r);
        },
            u = e(Pr).map(function (t) {
          return t && t[Br];
        }).filter(function (t) {
          return "function" == typeof t;
        }),
            c = u.map(function (t) {
          return Lr()(t, null, a);
        });

        return u.length ? Cr()([i].concat(Hr(c)))() : i();
      }
    }),
        Yr = yr({
      key: "@brainhubeu/react-carousel/nearestSlideSelector",
      get: function get(t) {
        var e = t.get,
            n = e(Wr),
            r = e(Ar).dragOffset,
            o = e(kr),
            a = e($r),
            i = function i() {
          var t = -Math.round(r / n);
          return Dr(o + t, a);
        },
            u = e(Pr).map(function (t) {
          return t && t[Ur];
        }).filter(function (t) {
          return "function" == typeof t;
        }),
            c = u.map(function (t) {
          return Lr()(t, null, o);
        });

        return u.length ? Cr()([i].concat(Hr(c)))() : i();
      }
    }),
        Kr = n(36),
        Jr = function Jr(t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    },
        Qr = n(105),
        Zr = "object" == typeof self && self && self.Object === Object && self,
        to = Qr.a || Zr || Function("return this")(),
        eo = function eo() {
      return to.Date.now();
    },
        no = to.Symbol,
        ro = Object.prototype,
        oo = ro.hasOwnProperty,
        ao = ro.toString,
        io = no ? no.toStringTag : void 0,
        uo = Object.prototype.toString,
        co = no ? no.toStringTag : void 0,
        so = function so(t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : co && co in Object(t) ? function (t) {
        var e = oo.call(t, io),
            n = t[io];

        try {
          t[io] = void 0;
          var r = !0;
        } catch (t) {}

        var o = ao.call(t);
        return r && (e ? t[io] = n : delete t[io]), o;
      }(t) : function (t) {
        return uo.call(t);
      }(t);
    },
        lo = /^\s+|\s+$/g,
        fo = /^[-+]0x[0-9a-f]+$/i,
        po = /^0b[01]+$/i,
        ho = /^0o[0-7]+$/i,
        vo = parseInt,
        bo = function bo(t) {
      if ("number" == typeof t) return t;
      if (function (t) {
        return "symbol" == typeof t || function (t) {
          return null != t && "object" == typeof t;
        }(t) && "[object Symbol]" == so(t);
      }(t)) return NaN;

      if (Jr(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = Jr(e) ? e + "" : e;
      }

      if ("string" != typeof t) return 0 === t ? t : +t;
      t = t.replace(lo, "");
      var n = po.test(t);
      return n || ho.test(t) ? vo(t.slice(2), n ? 2 : 8) : fo.test(t) ? NaN : +t;
    },
        yo = Math.max,
        go = Math.min,
        mo = function mo(t, e, n) {
      var r,
          o,
          a,
          i,
          u,
          c,
          s = 0,
          l = !1,
          f = !1,
          p = !0;
      if ("function" != typeof t) throw new TypeError("Expected a function");

      function d(e) {
        var n = r,
            a = o;
        return r = o = void 0, s = e, i = t.apply(a, n);
      }

      function h(t) {
        return s = t, u = setTimeout(b, e), l ? d(t) : i;
      }

      function v(t) {
        var n = t - c;
        return void 0 === c || n >= e || n < 0 || f && t - s >= a;
      }

      function b() {
        var t = eo();
        if (v(t)) return y(t);
        u = setTimeout(b, function (t) {
          var n = e - (t - c);
          return f ? go(n, a - (t - s)) : n;
        }(t));
      }

      function y(t) {
        return u = void 0, p && r ? d(t) : (r = o = void 0, i);
      }

      function g() {
        var t = eo(),
            n = v(t);

        if (r = arguments, o = this, c = t, n) {
          if (void 0 === u) return h(c);
          if (f) return clearTimeout(u), u = setTimeout(b, e), d(c);
        }

        return void 0 === u && (u = setTimeout(b, e)), i;
      }

      return e = bo(e) || 0, Jr(n) && (l = !!n.leading, a = (f = "maxWait" in n) ? yo(bo(n.maxWait) || 0, e) : a, p = "trailing" in n ? !!n.trailing : p), g.cancel = function () {
        void 0 !== u && clearTimeout(u), s = 0, r = c = o = u = void 0;
      }, g.flush = function () {
        return void 0 === u ? i : y(eo());
      }, g;
    },
        _o = {
      debounce: mo,
      throttle: function throttle(t, e, n) {
        var r = !0,
            o = !0;
        if ("function" != typeof t) throw new TypeError("Expected a function");
        return Jr(n) && (r = "leading" in n ? !!n.leading : r, o = "trailing" in n ? !!n.trailing : o), mo(t, e, {
          leading: r,
          maxWait: e,
          trailing: o
        });
      }
    },
        wo = function wo(t) {
      return "function" == typeof t;
    },
        Oo = function Oo() {
      return "undefined" == typeof window;
    },
        So = function So(t) {
      return t instanceof Element || t instanceof HTMLDocument;
    };

    function jo(t) {
      return (jo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Eo(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Ao(t, e) {
      return (Ao = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function xo(t, e) {
      return !e || "object" !== jo(e) && "function" != typeof e ? To(t) : e;
    }

    function To(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function Ro(t) {
      return (Ro = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function Po(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var ko = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ao(t, e);
      }(u, t);

      var e,
          n,
          i = function (t) {
        var e = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }();

        return function () {
          var n,
              r = Ro(t);

          if (e) {
            var o = Ro(this).constructor;
            n = Reflect.construct(r, arguments, o);
          } else n = r.apply(this, arguments);

          return xo(this, n);
        };
      }(u);

      function u(t) {
        var e;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), Po(To(e = i.call(this, t)), "cancelHandler", function () {
          e.resizeHandler && e.resizeHandler.cancel && (e.resizeHandler.cancel(), e.resizeHandler = null);
        }), Po(To(e), "rafClean", function () {
          e.raf && e.raf.cancel && (e.raf.cancel(), e.raf = null);
        }), Po(To(e), "toggleObserver", function (t) {
          var n = e.getElement();
          n && e.resizeObserver[t] && e.resizeObserver[t](n);
        }), Po(To(e), "getElement", function () {
          var t = e.props,
              n = t.querySelector,
              r = t.targetDomEl;

          if (!Oo()) {
            if (n) return document.querySelector(n);
            if (r && So(r)) return r;
            if (e.targetRef && So(e.targetRef.current)) return e.targetRef.current;
            var o = Object(a.findDOMNode)(To(e));
            if (o) switch (e.getRenderType()) {
              case "renderProp":
              case "childFunction":
              case "child":
              case "childArray":
                return o;

              default:
                return o.parentElement;
            }
          }
        }), Po(To(e), "createUpdater", function () {
          return e.rafClean(), e.raf = function (t) {
            var e = [],
                n = null,
                r = function r() {
              for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) {
                o[a] = arguments[a];
              }

              e = o, n || (n = requestAnimationFrame(function () {
                n = null, t.apply(void 0, e);
              }));
            };

            return r.cancel = function () {
              n && (cancelAnimationFrame(n), n = null);
            }, r;
          }(function (t) {
            var n = t.width,
                r = t.height,
                o = e.props.onResize;
            wo(o) && o(n, r), e.setState({
              width: n,
              height: r
            });
          }), e.raf;
        }), Po(To(e), "createResizeHandler", function (t) {
          var n = e.state,
              r = n.width,
              o = n.height,
              a = e.props,
              i = a.handleWidth,
              u = a.handleHeight;

          if (i || u) {
            var c = e.createUpdater();
            t.forEach(function (t) {
              var n = t && t.contentRect || {},
                  a = n.width,
                  s = n.height,
                  l = i && r !== a || u && o !== s;
              !e.skipOnMount && l && !Oo() && c({
                width: a,
                height: s
              }), e.skipOnMount = !1;
            });
          }
        }), Po(To(e), "getRenderType", function () {
          var t = e.props,
              n = t.render,
              o = t.children;
          return wo(n) ? "renderProp" : wo(o) ? "childFunction" : Object(r.isValidElement)(o) ? "child" : Array.isArray(o) ? "childArray" : "parent";
        });
        var n = t.skipOnMount,
            o = t.refreshMode,
            c = t.refreshRate,
            s = t.refreshOptions;
        e.state = {
          width: void 0,
          height: void 0
        }, e.skipOnMount = n, e.raf = null, e.unmounted = !1, e.targetRef = Object(r.createRef)();
        var l = _o[o];
        return e.resizeHandler = l ? l(e.createResizeHandler, c, s) : e.createResizeHandler, e.resizeObserver = new Kr.a(e.resizeHandler), e;
      }

      return e = u, (n = [{
        key: "componentDidMount",
        value: function value() {
          var t = this.props.targetRef;
          t && t.current && (this.targetRef.current = t.current), this.toggleObserver("observe");
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.toggleObserver("unobserve"), this.rafClean(), this.cancelHandler(), this.unmounted = !0;
        }
      }, {
        key: "render",
        value: function value() {
          var t = this.props,
              e = t.render,
              n = t.children,
              a = t.nodeType,
              i = this.state,
              u = {
            width: i.width,
            height: i.height,
            targetRef: this.targetRef
          };

          switch (this.getRenderType()) {
            case "renderProp":
              return e(u);

            case "childFunction":
              return n(u);

            case "child":
              if ("string" == typeof n.type) {
                var c = function (t, e) {
                  if (null == t) return {};

                  var n,
                      r,
                      o = function (t, e) {
                    if (null == t) return {};
                    var n,
                        r,
                        o = {},
                        a = Object.keys(t);

                    for (r = 0; r < a.length; r++) {
                      n = a[r], e.indexOf(n) >= 0 || (o[n] = t[n]);
                    }

                    return o;
                  }(t, e);

                  if (Object.getOwnPropertySymbols) {
                    var a = Object.getOwnPropertySymbols(t);

                    for (r = 0; r < a.length; r++) {
                      n = a[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (o[n] = t[n]);
                    }
                  }

                  return o;
                }(u, ["targetRef"]);

                return Object(r.cloneElement)(n, c);
              }

              return Object(r.cloneElement)(n, u);

            case "childArray":
              return n.map(function (t) {
                return !!t && Object(r.cloneElement)(t, u);
              });

            default:
              return o.a.createElement(a, null);
          }
        }
      }]) && Eo(e.prototype, n), u;
    }(r.PureComponent);

    ko.propTypes = {
      handleWidth: Er.bool,
      handleHeight: Er.bool,
      skipOnMount: Er.bool,
      refreshRate: Er.number,
      refreshMode: Er.string,
      refreshOptions: Object(Er.shape)({
        leading: Er.bool,
        trailing: Er.bool
      }),
      querySelector: Er.string,
      targetDomEl: Er.any,
      targetRef: Object(Er.oneOfType)([Er.func, Object(Er.shape)({
        current: Er.any
      })]),
      onResize: Er.func,
      render: Er.func,
      children: Er.any,
      nodeType: Er.node
    }, ko.defaultProps = {
      handleWidth: !0,
      handleHeight: !0,
      skipOnMount: !1,
      refreshRate: 1e3,
      refreshMode: void 0,
      refreshOptions: void 0,
      querySelector: null,
      targetDomEl: null,
      targetRef: null,
      onResize: null,
      render: void 0,
      children: null,
      nodeType: "div"
    };
    var Mo = ko;

    function Co(t) {
      return (Co = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function No() {
      return (No = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    function Lo(t, e) {
      if (null == t) return {};

      var n,
          r,
          o = function (t, e) {
        if (null == t) return {};
        var n,
            r,
            o = {},
            a = Object.keys(t);

        for (r = 0; r < a.length; r++) {
          n = a[r], e.indexOf(n) >= 0 || (o[n] = t[n]);
        }

        return o;
      }(t, e);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);

        for (r = 0; r < a.length; r++) {
          n = a[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (o[n] = t[n]);
        }
      }

      return o;
    }

    function Do(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Io(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Vo(t, e, n) {
      return e && Io(t.prototype, e), n && Io(t, n), t;
    }

    function Bo(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && function (t, e) {
        (Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        })(t, e);
      }(t, e);
    }

    function Uo(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = zo(t);

        if (e) {
          var o = zo(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Fo(this, n);
      };
    }

    function Fo(t, e) {
      return !e || "object" !== Co(e) && "function" != typeof e ? Wo(t) : e;
    }

    function Wo(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function zo(t) {
      return (zo = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function $o(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var Ho = n(5),
        Go = n.n(Ho),
        qo = n(101),
        Xo = n.n(qo),
        Yo = function Yo(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : window,
          a = Object(r.useRef)();
      Object(r.useEffect)(function () {
        a.current = e;
      }, [e]), Object(r.useEffect)(function () {
        if (o && o.addEventListener) {
          var e = function e(t) {
            return a.current(t);
          };

          return o.addEventListener(t, e, n), function () {
            o.removeEventListener(t, e);
          };
        }
      }, [t, o]);
    },
        Ko = n(102),
        Jo = n.n(Ko),
        Qo = function Qo(t) {
      var e = t.changedTouches[0],
          n = e.screenX,
          r = e.screenY,
          o = e.clientX,
          a = e.clientY,
          i = new MouseEvent({
        touchstart: "mousedown",
        touchmove: "mousemove",
        touchend: "mouseup"
      }[t.type], {
        bubbles: !0,
        cancelable: !0,
        view: window,
        detail: 1,
        screenX: n,
        screenY: r,
        clientX: o,
        clientY: a
      });
      e.target.dispatchEvent(i);
    },
        Zo = function Zo(t, e) {
      return t ? Array.isArray(t) ? t : [t] : e || [];
    },
        ta = n(35),
        ea = n.n(ta),
        na = n(103),
        ra = n.n(na),
        oa = {
      numberOfSlides: 3
    },
        aa = function aa(t) {
      var e = t.carouselProps,
          n = t.refs,
          o = t.options,
          a = void 0 === o ? oa : o;
      return {
        name: ni.SLIDES_TO_SHOW,
        plugin: function plugin() {
          var t = Object(r.useRef)(!0),
              o = _r(Wr),
              i = function i() {
            o(n.trackContainerRef.current.offsetWidth / a.numberOfSlides);
          };

          Object(r.useEffect)(function () {
            t.current ? t.current = !1 : i();
          }, [e.width, n.trackContainerRef.current]), Yo("resize", i), Yo("load", i);
        }
      };
    },
        ia = n(61),
        ua = n.n(ia),
        ca = n(104),
        sa = n.n(ca);

    function la(t) {
      return function (t) {
        if (Array.isArray(t)) return va(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
      }(t) || ha(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function fa(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function pa(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? fa(Object(n), !0).forEach(function (e) {
          da(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : fa(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function da(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function ha(t, e) {
      if (t) {
        if ("string" == typeof t) return va(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? va(t, e) : void 0;
      }
    }

    function va(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    var ba = {
      numberOfInfiniteClones: 2
    },
        ya = function ya(t) {
      var e = t.options,
          n = void 0 === e ? ba : e,
          o = t.carouselProps,
          a = gr(Wr),
          i = Zo(o.children, o.slides),
          u = function u() {
        return Math.abs(o.value) > i.length ? Math.ceil(o.value / i.length) : 0;
      },
          c = function c() {
        var t = u();
        return t < 0 ? -t : 0;
      },
          s = function s() {
        return -i.length * a * c();
      };

      return {
        name: ni.INFINITE,
        plugin: function plugin() {
          var t = _r(Tr),
              e = _r(Fr),
              a = function (t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
                var n = [],
                    r = !0,
                    o = !1,
                    a = void 0;

                try {
                  for (var i, u = t[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !e || n.length !== e); r = !0) {
                    ;
                  }
                } catch (t) {
                  o = !0, a = t;
                } finally {
                  try {
                    r || null == u.return || u.return();
                  } finally {
                    if (o) throw a;
                  }
                }

                return n;
              }
            }(t, e) || ha(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }(mr(Rr), 2),
              l = a[0],
              f = a[1],
              p = _r($r),
              d = n.numberOfInfiniteClones,
              h = function h() {
            return d + c();
          },
              v = function v() {
            return d + ((t = u()) > 0 ? t : 0);
            var t;
          };

          Object(r.useEffect)(function () {
            e(function () {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                  e = Or()(t) ? o.value : t,
                  n = i.length;
              return e >= 0 ? e % n : (n - Math.abs(e % n)) % n;
            }(0) + o.value + h() * i.length), f(pa(pa({}, l), {}, {
              marginLeft: s()
            }));
          }, [o.value]), Object(r.useEffect)(function () {
            var e = 1 + h() + v(),
                n = ua()(h(), function () {
              return i;
            }),
                r = ua()(v(), function () {
              return i;
            });
            t(o.width * i.length * e), p(sa.a.apply(void 0, la(n).concat([i], la(r))));
          }, [o.width, i.length, o.value]);
        },
        strategies: function strategies() {
          var t,
              e = gr(Ar),
              n = gr(Fr),
              r = gr(Wr),
              i = (e.marginLeft || "0").match(/\d/g).join("");
          return da(t = {}, Ir, function (t) {
            return t;
          }), da(t, Ur, function (t) {
            return t + -Math.round(e.dragOffset / r);
          }), da(t, Vr, function () {
            return o.value;
          }), da(t, Br, function () {
            var t = a;
            return e.dragOffset - n * t - i - s();
          }), t;
        }
      };
    };

    function ga(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function ma(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ga(Object(n), !0).forEach(function (e) {
          wa(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ga(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function _a(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function wa(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var Oa = 0,
        Sa = function Sa(t) {
      var e = t.carouselProps;
      return {
        name: ni.CLICK_TO_CHANGE,
        strategies: function strategies() {
          var t = gr(Ar),
              n = gr(Fr);
          return wa({}, Ir, function (r, o) {
            var a,
                i,
                u = (a = Math.abs(t.dragStart)) < (i = Math.abs(t.dragEnd) || 0) ? "LEFT" : a > i ? "RIGHT" : "NONE";
            return "NONE" === u ? o : Oa !== t.clicked ? "LEFT" === u && o <= t.clicked ? (Oa = o, o) : (Oa = t.clicked, n ? e.value + t.clicked - n : t.clicked) : (Oa = o || r, o || r);
          });
        },
        slideCustomProps: function slideCustomProps() {
          var t = _r(xr),
              e = function (t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
                var n = [],
                    r = !0,
                    o = !1,
                    a = void 0;

                try {
                  for (var i, u = t[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !e || n.length !== e); r = !0) {
                    ;
                  }
                } catch (t) {
                  o = !0, a = t;
                } finally {
                  try {
                    r || null == u.return || u.return();
                  } finally {
                    if (o) throw a;
                  }
                }

                return n;
              }
            }(t, e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return _a(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _a(t, e) : void 0;
              }
            }(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }(mr(Ar), 2),
              n = e[0],
              o = e[1];

          return {
            onMouseDown: Object(r.useCallback)(function (e, r) {
              e.preventDefault(), e.stopPropagation(), t(!0);
              var a = e.pageX;
              o(ma(ma({}, n), {}, {
                clicked: r,
                dragStart: a
              }));
            }, [n, t])
          };
        },
        itemClassNames: function itemClassNames() {
          return ["BrainhubCarouselItem--clickable"];
        }
      };
    };

    function ja(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function Ea(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function Aa(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ea(Object(n), !0).forEach(function (e) {
          xa(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ea(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function xa(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var Ta = null,
        Ra = {
      interval: 2e3,
      stopAutoPlayOnHover: !0,
      direction: "RIGHT"
    },
        Pa = function Pa(t) {
      var e = t.carouselProps,
          n = t.options,
          o = void 0 === n ? {} : n,
          a = Aa(Aa({}, Ra), o);
      return {
        name: ni.AUTOPLAY,
        trackCustomProps: function trackCustomProps() {
          var t = _r(qr),
              n = function (t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
                var n = [],
                    r = !0,
                    o = !1,
                    a = void 0;

                try {
                  for (var i, u = t[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !e || n.length !== e); r = !0) {
                    ;
                  }
                } catch (t) {
                  o = !0, a = t;
                } finally {
                  try {
                    r || null == u.return || u.return();
                  } finally {
                    if (o) throw a;
                  }
                }

                return n;
              }
            }(t, e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return ja(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ja(t, e) : void 0;
              }
            }(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }(Object(r.useState)(!1), 2),
              o = n[0],
              i = n[1],
              u = function u() {
            Ta && clearInterval(Ta), Ta = setInterval(function () {
              if (!document.hidden && !o) {
                var n = e.value + ("LEFT" === (r = a.direction.toUpperCase()) ? -1 : "RIGHT" === r ? 1 : 0);
                e.onChange(n), t(n);
              }

              var r;
            }, a.interval);
          };

          return u(), {
            onMouseEnter: a.stopAutoPlayOnHover ? function () {
              i(!0);
            } : null,
            onMouseLeave: a.stopAutoPlayOnHover ? function () {
              i(!1), u();
            } : null
          };
        }
      };
    };

    function ka(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function Ma(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ka(Object(n), !0).forEach(function (e) {
          Ca(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ka(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function Ca(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function Na(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
          var n = [],
              r = !0,
              o = !1,
              a = void 0;

          try {
            for (var i, u = t[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !e || n.length !== e); r = !0) {
              ;
            }
          } catch (t) {
            o = !0, a = t;
          } finally {
            try {
              r || null == u.return || u.return();
            } finally {
              if (o) throw a;
            }
          }

          return n;
        }
      }(t, e) || function (t, e) {
        if (t) {
          if ("string" == typeof t) return La(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? La(t, e) : void 0;
        }
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function La(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    n(239);

    var Da,
        Ia = function Ia(t) {
      var e = t.carouselProps;
      return {
        name: ni.RTL,
        plugin: function plugin() {
          var t = Na(mr(Rr), 2),
              n = t[0],
              o = t[1],
              a = gr($r);
          Object(r.useEffect)(function () {
            var t;
            (null == e || null === (t = e.children) || void 0 === t ? void 0 : t.length) !== a.length && o(Ma(Ma({}, n), {}, {
              transform: -e.transformOffset
            }));
          }, [e.transformOffset]);
        },
        strategies: function strategies() {
          var t,
              e = gr($r),
              n = gr(Ar),
              r = gr(kr);
          return Ca(t = {}, Ir, function (t, o) {
            if (n.dragOffset) return Dr(t, e);
            var a = r + (o - r);
            return t !== o ? Dr(a, e) : a;
          }), Ca(t, Br, function (t, e) {
            return -e;
          }), t;
        },
        carouselClassNames: function carouselClassNames() {
          var t = gr($r),
              n = [];
          return e.children.length === t.length && n.push("BrainhubCarousel--isRTL"), n;
        },
        carouselCustomProps: function carouselCustomProps() {
          var t = Na(mr(Ar), 2),
              e = t[0],
              n = t[1];
          return {
            onMouseMove: Object(r.useCallback)(function (t) {
              var r = t.pageX;
              null !== e.dragStart && n(function (t) {
                return Ma(Ma({}, e), {}, {
                  dragOffset: t.dragStart - r,
                  dragEnd: r
                });
              });
            }, [e])
          };
        }
      };
    },
        Va = function Va(t) {
      var e = t.refs;
      return {
        name: ni.CENTERED,
        strategies: function strategies() {
          var t,
              n,
              r,
              o,
              a,
              i = gr(Wr),
              u = gr(zr),
              c = null === (t = e.trackContainerRef) || void 0 === t || null === (n = t.current) || void 0 === n ? void 0 : n.offsetWidth;
          return a = function a(t, e) {
            return e + (c / 2 - (i + u) / 2);
          }, (o = Br) in (r = {}) ? Object.defineProperty(r, o, {
            value: a,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : r[o] = a, r;
        }
      };
    },
        Ba = {
      numberOfSlides: 3
    },
        Ua = function Ua(t) {
      var e = t.carouselProps,
          n = t.options,
          r = void 0 === n ? Ba : n;
      return {
        name: ni.SLIDES_TO_SCROLL,
        strategies: function strategies() {
          var t,
              n,
              o,
              a = gr(kr),
              i = gr($r);
          return o = function o(t, n) {
            var o,
                u = function (t, e) {
              return t < 0 ? -t - e : t > 0 ? e - t : 0;
            }(n - a, r.numberOfSlides);

            return (null == e || null === (o = e.children) || void 0 === o ? void 0 : o.length) !== i.length ? n + u : Dr(n + u, i);
          }, (n = Ir) in (t = {}) ? Object.defineProperty(t, n, {
            value: o,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[n] = o, t;
        }
      };
    },
        Fa = (n(243), function (t, e, n, r, a) {
      var i = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
      return o.a.createElement("div", {
        key: a,
        className: Go()("BrainhubCarousel__customArrows", {
          "BrainhubCarousel__arrow--disable": i
        }, "BrainhubCarousel__custom-".concat(n)),
        onClick: r ? e : null
      }, t);
    }),
        Wa = o.a.createElement("span", null, "prev"),
        za = o.a.createElement("span", null, "next"),
        $a = function $a(t) {
      var e = t.carouselProps,
          n = t.options,
          a = void 0 === n ? {} : n;
      return {
        name: ni.ARROWS,
        beforeCarouselItems: function beforeCarouselItems() {
          var t,
              n = gr($r),
              i = Object(r.useCallback)(function () {
            return e.onChange(e.value - 1);
          }, [e.value, e.onChange]),
              u = e.value <= 0 && (null == e || null === (t = e.children) || void 0 === t ? void 0 : t.length) === n.length;

          if (a.arrowLeft) {
            if (!u) return Fa(a.arrowLeft, i, "arrowLeft", a.addArrowClickHandler, "@brainhubeu/react-carousel/custom-arrow-left");
            var c = a.arrowLeftDisabled ? a.arrowLeftDisabled : a.arrowLeft;
            return Fa(c, i, "arrowLeft", a.addArrowClickHandler, "@brainhubeu/react-carousel/custom-arrow-left", u);
          }

          return o.a.createElement("button", {
            key: "@brainhubeu/react-carousel/arrow-left",
            className: "BrainhubCarousel__arrows BrainhubCarousel__arrowLeft",
            onClick: i,
            disabled: u
          }, Wa);
        },
        afterCarouselItems: function afterCarouselItems() {
          var t,
              n = gr($r),
              i = Object(r.useCallback)(function () {
            return e.onChange(e.value + 1);
          }, [e.value, e.onChange]),
              u = e.value >= n.length - 1 && (null == e || null === (t = e.children) || void 0 === t ? void 0 : t.length) === n.length;

          if (a.arrowRight) {
            if (!u) return Fa(a.arrowRight, i, "arrowLeft", a.addArrowClickHandler, "@brainhubeu/react-carousel/custom-arrow-right");
            var c = a.arrowRightDisabled ? a.arrowRightDisabled : a.arrowRight;
            return Fa(c, i, "arrowLeft", a.addArrowClickHandler, "@brainhubeu/react-carousel/custom-arrow-right", u);
          }

          return o.a.createElement("button", {
            key: "@brainhubeu/react-carousel/arrow-right",
            className: "BrainhubCarousel__arrows BrainhubCarousel__arrowRight",
            onClick: i,
            disabled: u
          }, za);
        }
      };
    },
        Ha = function Ha(t) {
      var e = t.carouselProps;
      return {
        name: ni.FAST_SWIPE,
        strategies: function strategies() {
          var t = gr(Ar).dragOffset,
              n = gr(kr);
          return function (t, e, n) {
            return e in t ? Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[e] = n, t;
          }({}, Ur, function () {
            var r = t > 0 ? -Math.ceil(t / e.width) : -Math.floor(t / e.width);
            return n + r;
          });
        }
      };
    };

    function Ga(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var qa = aa,
        Xa = ya,
        Ya = Sa,
        Ka = Pa,
        Ja = Ia,
        Qa = Va,
        Za = Ua,
        ti = $a,
        ei = Ha,
        ni = {
      SLIDES_TO_SHOW: "SLIDESTOSHOW",
      CLICK_TO_CHANGE: "CLICKTOCHANGE",
      INFINITE: "INFINITE",
      AUTOPLAY: "AUTOPLAY",
      RTL: "RTL",
      CENTERED: "CENTERED",
      SLIDES_TO_SCROLL: "SLIDESTOSCROLL",
      ARROWS: "ARROWS",
      FAST_SWIPE: "FASTSWIPE"
    },
        ri = (Ga(Da = {}, ni.SLIDES_TO_SHOW, qa), Ga(Da, ni.CLICK_TO_CHANGE, Ya), Ga(Da, ni.INFINITE, Xa), Ga(Da, ni.RTL, Ja), Ga(Da, ni.AUTOPLAY, Ka), Ga(Da, ni.CENTERED, Qa), Ga(Da, ni.SLIDES_TO_SCROLL, Za), Ga(Da, ni.ARROWS, ti), Ga(Da, ni.FAST_SWIPE, ei), Da),
        oi = [ni.FAST_SWIPE, ni.ARROWS, ni.SLIDES_TO_SHOW, ni.AUTOPLAY, ni.INFINITE, ni.RTL, ni.CLICK_TO_CHANGE, ni.CENTERED, ni.SLIDES_TO_SCROLL];

    function ai(t) {
      return function (t) {
        if (Array.isArray(t)) return ii(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
      }(t) || function (t, e) {
        if (t) {
          if ("string" == typeof t) return ii(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ii(t, e) : void 0;
        }
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function ii(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function ui(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function ci(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ui(Object(n), !0).forEach(function (e) {
          si(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ui(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function si(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function li(t) {
      return function (t) {
        if (Array.isArray(t)) return fi(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
      }(t) || function (t, e) {
        if (t) {
          if ("string" == typeof t) return fi(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? fi(t, e) : void 0;
        }
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function fi(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    n(245);
    var pi = Object(r.memo)(function (t) {
      var e = t.index,
          n = t.onMouseDown,
          a = t.onTouchStart,
          i = t.currentSlideIndex,
          u = t.isDraggingEnabled,
          c = t.itemClassNames,
          s = t.width,
          l = t.offset,
          f = t.isDragging,
          p = t.children,
          d = Object(r.useRef)(null),
          h = Object(r.useRef)(!0),
          v = function v() {
        d.current && (d.current.style = null, d.current.offsetWidth > s && (d.current.style.width = "".concat(s, "px")));
      };

      return Object(r.useEffect)(function () {
        var t;
        h.current ? h.current = !1 : (t = new Kr.a(function () {
          v(), d.current && t.unobserve(d.current);
        }), d.current && t.observe(d.current));
      }, []), Object(r.useEffect)(function () {
        v();
      }, [s]), o.a.createElement("li", {
        className: Go.a.apply(void 0, ["BrainhubCarouselItem", {
          "BrainhubCarouselItem--active": e === i
        }].concat(li(c || []))),
        style: {
          marginRight: "".concat(l / 2, "px"),
          marginLeft: "".concat(l / 2, "px"),
          width: "".concat(s, "px"),
          maxWidth: "".concat(s, "px"),
          minWidth: "".concat(s, "px"),
          pointerEvents: f ? "none" : null
        },
        onMouseDown: u ? function (t) {
          n(t, e);
        } : null,
        onTouchStart: u ? function (t) {
          a(t, e);
        } : null
      }, d.current ? o.a.cloneElement(p, {
        ref: d
      }) : p);
    });

    function di(t) {
      return function (t) {
        if (Array.isArray(t)) return _i(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
      }(t) || mi(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function hi() {
      return (hi = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    function vi(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function bi(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? vi(Object(n), !0).forEach(function (e) {
          yi(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : vi(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function yi(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function gi(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
          var n = [],
              r = !0,
              o = !1,
              a = void 0;

          try {
            for (var i, u = t[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !e || n.length !== e); r = !0) {
              ;
            }
          } catch (t) {
            o = !0, a = t;
          } finally {
            try {
              r || null == u.return || u.return();
            } finally {
              if (o) throw a;
            }
          }

          return n;
        }
      }(t, e) || mi(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function mi(t, e) {
      if (t) {
        if ("string" == typeof t) return _i(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _i(t, e) : void 0;
      }
    }

    function _i(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    n(247);

    var wi = function wi(t) {
      var e = gi(mr(Ar), 2),
          n = e[0],
          a = e[1],
          i = gi(mr(Wr), 2),
          u = i[0],
          c = i[1],
          s = _r(zr),
          l = gi(mr(Tr), 2),
          f = l[0],
          p = l[1],
          d = gi(mr(Fr), 1)[0],
          h = gi(mr(xr), 2),
          v = h[0],
          b = h[1],
          y = gi(mr(Rr), 2),
          g = y[0],
          m = y[1],
          _ = Zo(t.children, t.slides),
          w = gi(mr($r), 2),
          O = w[0],
          S = w[1],
          j = _r(Pr),
          E = Object(r.useRef)(!0),
          A = Object(r.useRef)(null),
          x = Object(r.useRef)(null),
          T = function (t, e, n, r) {
        var o = null == e ? void 0 : e.plugins.map(function (t) {
          return "string" == typeof t ? ri[t.toUpperCase()] && ri[t.toUpperCase()]({
            carouselProps: ci(ci({}, e), {}, {
              children: e.children ? e.children : e.slides
            }),
            options: t.options,
            refs: {
              trackContainerRef: n,
              carouselRef: r
            }
          }) : t.resolve({
            carouselProps: e,
            options: t.options,
            refs: {
              trackContainerRef: n,
              carouselRef: r
            }
          });
        }),
            a = ea()(o.map(function (t) {
          return t.itemClassNames && t.itemClassNames({
            carouselProps: e,
            options: t.options,
            refs: {
              trackContainerRef: n,
              carouselRef: r
            }
          });
        })).filter(function (t) {
          return "string" == typeof t;
        }),
            i = ea()(o.map(function (t) {
          return t.carouselClassNames && t.carouselClassNames({
            carouselProps: e,
            options: t.options,
            refs: {
              trackContainerRef: n,
              carouselRef: r
            }
          });
        })).filter(function (t) {
          return "string" == typeof t;
        }),
            u = Object.assign.apply(Object, [{}].concat(ai(o.map(function (t) {
          return t.carouselCustomProps && t.carouselCustomProps();
        })))),
            c = Object.assign.apply(Object, [{}].concat(ai(o.map(function (t) {
          return t.trackCustomProps && t.trackCustomProps();
        })))),
            s = Object.assign.apply(Object, [{}].concat(ai(o.map(function (t) {
          return t.slideCustomProps && t.slideCustomProps();
        }))));
        return {
          itemClassNames: a,
          carouselClassNames: i,
          beforeCarouselItems: o.map(function (t) {
            return t.beforeCarouselItems && t.beforeCarouselItems();
          }) || [],
          afterCarouselItems: o.map(function (t) {
            return t.afterCarouselItems && t.afterCarouselItems();
          }) || [],
          strategies: ra()(o, function (t) {
            return oi.indexOf(t.name);
          }).map(function (t) {
            return t.strategies && t.strategies();
          }),
          carouselCustomProps: u,
          trackCustomProps: c,
          slideCustomProps: s,
          carouselPlugins: o
        };
      }(t.plugins, t, x, A),
          R = T.carouselPlugins,
          P = T.itemClassNames,
          k = T.carouselClassNames,
          M = T.beforeCarouselItems,
          C = T.afterCarouselItems,
          N = T.strategies,
          L = T.carouselCustomProps,
          D = T.trackCustomProps,
          I = T.slideCustomProps;

      j(N);
      var V,
          B,
          U,
          F = Object(r.useCallback)(function (t) {
        var e = t.pageX;
        null !== n.dragStart && a(function (t) {
          return bi(bi({}, n), {}, {
            dragOffset: e - t.dragStart,
            dragEnd: e
          });
        });
      }, [n, b]),
          W = Object(r.useCallback)(function (t, e) {
        t.preventDefault(), t.stopPropagation(), b(!1);
        var r = t.pageX;
        a(bi(bi({}, n), {}, {
          clicked: e,
          dragStart: r
        }));
      }, [n, b]),
          z = Object(r.useCallback)(function (t, e) {
        var n = t.changedTouches;
        a({
          clicked: e,
          dragStart: n[0].pageX
        });
      }, []),
          $ = Object(r.useCallback)(function () {
        null !== n.dragStart && (t.onChange(t.nearestSlideIndex), a({
          clicked: null,
          dragOffset: 0,
          dragStart: null,
          dragEnd: null
        })), b(!0);
      }, [b, a, n]);
      return function (t) {
        var e = t.width,
            n = t.carouselRef,
            o = t.setItemWidth,
            a = t.trackContainerRef,
            i = Object(r.useRef)(!0),
            u = Jo()(function () {
          n && a && o(a.current.offsetWidth);
        }, 300);
        Object(r.useEffect)(function () {
          i.current ? i.current = !1 : u();
        }, [e, a.current]);
      }({
        carouselRef: A,
        itemWidth: u,
        setItemWidth: c,
        trackContainerRef: x,
        width: t.width
      }), Object(r.useEffect)(function () {
        S(_);
      }, [_]), Object(r.useEffect)(function () {
        s(t.offset);
      }, [t.offset]), Object(r.useEffect)(function () {
        E.current ? E.current = !1 : b(!0);
      }, [t.value]), Object(r.useEffect)(function () {
        var e = t.width * _.length;
        p(e);
      }, [t.width]), Object(r.useEffect)(function () {
        m(bi(bi({}, g), {}, {
          transform: t.transformOffset
        }));
      }, [t.transformOffset]), Yo("mouseup", $, {
        passive: !0,
        capture: !0
      }), Yo("touchstart", Qo, {
        passive: !0,
        capture: !0
      }, A.current), Yo("touchmove", Qo, A.current), Yo("touchend", Qo, {
        passive: !0,
        capture: !0
      }, A.current), null == R || R.forEach(function (t) {
        return "function" == typeof t ? t() : t.plugin && t.plugin();
      }), o.a.createElement("div", {
        className: "BrainhubCarousel__container"
      }, o.a.createElement("div", hi({
        className: Go.a.apply(void 0, ["BrainhubCarousel", t.className].concat(di(k || []))),
        onMouseMove: F,
        ref: A
      }, L), o.a.createElement(o.a.Fragment, null, M), (V = t.animationSpeed, B = t.draggable && _ && _.length > 1, U = {
        width: "".concat(f, "px"),
        transitionDuration: v ? "".concat(V, "ms, ").concat(V, "ms") : null,
        transform: "translateX(".concat(g.transform, "px)"),
        marginLeft: "".concat(g.marginLeft, "px"),
        marginRight: "".concat(g.marginRight, "px")
      }, o.a.createElement("div", {
        className: "BrainhubCarousel__trackContainer",
        ref: x
      }, o.a.createElement("ul", hi({
        className: Go()("BrainhubCarousel__track", {
          "BrainhubCarousel__track--transition": v,
          "BrainhubCarousel__track--draggable": B
        }),
        style: U
      }, D), Xo()(O).map(function (e, r) {
        return o.a.createElement(pi, hi({
          clickable: !0,
          key: r,
          currentSlideIndex: d || t.value,
          index: r,
          width: t.itemWidth || u,
          offset: r !== O.length ? t.offset : 0,
          onMouseDown: W,
          onTouchStart: z,
          isDragging: Math.abs(n.dragOffset) > 10,
          itemClassNames: P,
          isDraggingEnabled: t.draggable
        }, I), e);
      })))), o.a.createElement(o.a.Fragment, null, C)));
    };

    wi.defaultProps = {
      slidesPerPage: 1,
      offset: 0,
      animationSpeed: 500,
      draggable: !0,
      plugins: []
    };

    var Oi = function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        handleWidth: !0,
        handleHeight: !0
      },
          n = function (n) {
        Bo(i, n);
        var a = Uo(i);

        function i() {
          var t;
          Do(this, i);

          for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) {
            n[o] = arguments[o];
          }

          return $o(Wo(t = a.call.apply(a, [this].concat(n))), "ref", Object(r.createRef)()), t;
        }

        return Vo(i, [{
          key: "render",
          value: function value() {
            var n = this.props,
                r = n.forwardedRef,
                a = Lo(n, ["forwardedRef"]),
                i = r || this.ref;
            return o.a.createElement(Mo, No({}, e, {
              targetRef: i
            }), o.a.createElement(t, No({
              targetRef: i
            }, a)));
          }
        }]), i;
      }(o.a.Component);

      function a(t, e) {
        return o.a.createElement(n, No({}, t, {
          forwardedRef: e
        }));
      }

      var i = t.displayName || t.name;
      return a.displayName = "withResizeDetector(".concat(i, ")"), n.propTypes = {
        forwardedRef: Object(Er.oneOfType)([Er.func, Object(Er.shape)({
          current: Er.any
        })])
      }, n.defaultProps = {
        forwardedRef: void 0
      }, Object(r.forwardRef)(a);
    }(o.a.memo(wi));

    function Si() {
      return (Si = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    function ji(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function Ei(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ji(Object(n), !0).forEach(function (e) {
          Ai(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ji(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function Ai(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function xi(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
          var n = [],
              r = !0,
              o = !1,
              a = void 0;

          try {
            for (var i, u = t[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !e || n.length !== e); r = !0) {
              ;
            }
          } catch (t) {
            o = !0, a = t;
          } finally {
            try {
              r || null == u.return || u.return();
            } finally {
              if (o) throw a;
            }
          }

          return n;
        }
      }(t, e) || function (t, e) {
        if (t) {
          if ("string" == typeof t) return Ti(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ti(t, e) : void 0;
        }
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Ti(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    var Ri = function Ri(t) {
      var e,
          n = _r(qr),
          a = gr(kr),
          i = _r(xr);

      Object(r.useEffect)(function () {
        Or()(t.value) || n(t.value);
      }, [t.value, i]);

      var u = t.onChange,
          c = t.value,
          s = function (t, e) {
        if (null == t) return {};

        var n,
            r,
            o = function (t, e) {
          if (null == t) return {};
          var n,
              r,
              o = {},
              a = Object.keys(t);

          for (r = 0; r < a.length; r++) {
            n = a[r], e.indexOf(n) >= 0 || (o[n] = t[n]);
          }

          return o;
        }(t, e);

        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(t);

          for (r = 0; r < a.length; r++) {
            n = a[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (o[n] = t[n]);
          }
        }

        return o;
      }(t, ["onChange", "value"]),
          l = gr(Xr),
          f = gr(Yr),
          p = Object.entries(s.breakpoints || {}).filter(function (t) {
        var e = xi(t, 1)[0];
        return window.innerWidth <= e;
      }).sort(function (t, e) {
        var n = xi(t, 1)[0];
        return xi(e, 1)[0] - n;
      }).reduce(function (t, e) {
        var n = xi(e, 2),
            r = (n[0], n[1]);
        return Ei(Ei({}, t), r);
      }, jr()(s, ["breakpoints"])),
          d = !Or()(c);

      return o.a.createElement(Oi, Si({
        key: (null == p || null === (e = p.plugins) || void 0 === e ? void 0 : e.length) || 0,
        transformOffset: l,
        nearestSlideIndex: f,
        value: a,
        onChange: d ? u : n
      }, p));
    },
        Pi = (n(249), function (t) {
      var e = t.value,
          n = t.thumbnails,
          r = t.number,
          a = t.onChange,
          i = t.rtl,
          u = t.className,
          c = function c() {
        var t = r || n.length;
        return e >= 0 ? e : e + t * Math.ceil(Math.abs(e / t));
      },
          s = function s(t) {
        return function () {
          var o = r || n.length,
              i = c() % o;
          return a(e - (i - t));
        };
      };

      return o.a.createElement("ul", {
        className: Go()("BrainhubCarousel__dots", u, i ? "BrainhubCarousel__dots--isRTL" : "")
      }, function () {
        if (n) {
          var t = isNaN(r) ? n.length : r;
          return n.slice(0, t).map(function (e, n) {
            return o.a.createElement("li", {
              key: n
            }, o.a.createElement("div", {
              className: Go()("BrainhubCarousel__thumbnail", {
                "BrainhubCarousel__thumbnail--selected": n === c() % t
              }),
              type: "button",
              onClick: s(n)
            }, e));
          });
        }

        for (var e = [], a = 0; a < r; a++) {
          e.push(o.a.createElement("li", {
            key: a
          }, o.a.createElement("div", {
            className: Go()("BrainhubCarousel__dot", {
              "BrainhubCarousel__dot--selected": a === c() % r
            }),
            type: "button",
            onClick: s(a)
          }, a + 1)));
        }

        return e;
      }());
    }),
        ki = aa,
        Mi = ya,
        Ci = Sa,
        Ni = Pa,
        Li = Ia,
        Di = Va,
        Ii = Ua,
        Vi = $a,
        Bi = Ha,
        Ui = o.a.memo(Pi);

    e.default = function (t) {
      return o.a.createElement(vr, null, o.a.createElement(Ri, t));
    };
  },, function (t, e) {},,,, function (t, e) {},, function (t, e) {},, function (t, e) {},, function (t, e) {}]);
});